export const Text = {
    Common: {
        // TODO: Layout
        Back: { CHI: '返回', ENG: 'Back' },
        Classes: { CHI: '班別', ENG: 'Classes' },
        ClassNo: { CHI: '班號', ENG: 'Class No.' },
        Close: { CHI: '關閉', ENG: 'Close' },
        FormJunior: { CHI: '初中', ENG: 'Junior Form' },
        FormSenior: { CHI: '高中', ENG: 'Senior Form' },
        Loading: { CHI: '載入中', ENG: 'Loading' },
        Navigate: { CHI: '導航', ENG: 'Navigate' },
        NoDataAvailable: { CHI: '暫無資料', ENG: 'No Data Available' },
        Submit: { CHI: '送出', ENG: 'Submit' },
        StudentName: { CHI: '學生姓名', ENG: 'Student Name' },
        UploadFiles: { CHI: '上載檔案', ENG: 'Upload File(s)' },
        // TODO: Info
        SchoolName: { CHI: '博愛醫院八十週年鄧英喜中學', ENG: 'Pok Oi Hospital 80th Anniversary Tang Ying Hei College' },
        ClassLevel: {
            1: { CHI: '中一', ENG: 'F.1' },
            2: { CHI: '中二', ENG: 'F.2' },
            3: { CHI: '中三', ENG: 'F.3' },
            4: { CHI: '中四', ENG: 'F.4' },
            5: { CHI: '中五', ENG: 'F.5' },
            6: { CHI: '中六', ENG: 'F.6' },
        },
        Society: {
            Title: { CHI: '社', ENG: 'Society' },
            R: { CHI: '博社', ENG: 'Ruby' },
            Y: { CHI: '文社', ENG: 'Topaz' },
            B: { CHI: '愛社', ENG: 'Sapphire' },
            G: { CHI: '德社', ENG: 'Emerald' },
        },
    },
    Home: {
        Focus: {
            Title: { CHI: '焦點', ENG: 'Focus' },
        },
        More: {
            Title: { CHI: '更多資訊', ENG: 'More' },
        },
        News: {
            Title: { CHI: '最新消息', ENG: 'News' },
            More: { CHI: '更多消息', ENG: 'More' },
        },
        UsefulLinks: {
            Title: { CHI: '常用連結', ENG: 'Useful Links' },
        },
    },
    Achievements: {
        AwardsExternal: {
            Organizer: { CHI: '主辦機構', ENG: 'Organizer' },
            Items: { CHI: '比賽項目及名次', ENG: 'Competition Items and Rankings' },
            AwardDate: { CHI: '得獎日期', ENG: 'Award Date' },
        },
        DSEResult2024: {
            Title: { CHI: '2024 中學文憑試成績', ENG: '2024 HKDSE Results' },
        },
        DSEResult2025: {
            Title: { CHI: '2025 中學文憑試成績', ENG: '2025 HKDSE Results' },
        },
        DSEResult2026: {
            Title: { CHI: '2026 中學文憑試成績', ENG: '2026 HKDSE Results' },
        },
    },
    Activities: {
        HappyFriday: {
            Description: {
                CHI: '本校特設安排聯課活動課，豐富學生學習經歷及建立生活品味。<br /><br />提供40多個學會/興趣班供學生選擇，其中涵蓋不同學習與藝術領域，包括女子瑜珈班、健身學會、舞蹈學會、DREAM MUSIC TEAM、攝影學會、素描班、韓語班、日語班、花藝班、咖啡拉花學會、手遊程式設計學會等。',
                ENG: 'Award Date',
            },
            NonHappyFriday: { CHI: '非愉快星期五', ENG: 'Non-Happy Friday' },
            NSociety: [
                {
                    ID: 'society_ams',
                    CHI: '醫療輔助隊少年團',
                    ENG: 'Auxiliary Medical Service Cadet Corps',
                    Description: {
                        CHI: '醫療輔助隊少年團是由政府部門成立的青少年制服團體。<br /><br />少年團致力向團員教授醫療、衞生及健康方面的專業知識及技能，並透過紀律訓練培養他們的自律性和責任感。少年團亦為團員組織各類群體活動，使他們從中學會待人接物，並培養自信心、服務精神及領導才能。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_badminton',
                    CHI: '羽毛球隊',
                    ENG: 'Badminton',
                    Description: {
                        CHI: '羽毛球是一項深受同學喜愛的體育運動。本校羽毛球的成立，宗旨在校內推廣羽毛球運動之發展，在專業教練及老師指導下提供有系統的訓練，培育一群優秀的羽毛球運動員。羽毛球校隊每年都參加學界比賽，從中觀摩學習，獲益良多。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_baseballSoftball',
                    CHI: '棒壘球隊',
                    ENG: 'Baseball Softball',
                    Description: {
                        CHI: '棒球、壘球是一種全面性運動，不單可增強體格、判斷能力、是非的判斷，還可以鍛鍊團隊合作精神，因此本校設立了棒壘球隊。隊員除了接受棒球常規訓練外，亦會接受壘球訓練，讓學生同時接觸兩項體育運動。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_basketball',
                    CHI: '籃球隊',
                    ENG: 'Basketball',
                    Description: {
                        CHI: '透過籃球訓練，提升同學對運動的興趣，改善身體素質，鍛煉同學的刻苦精神，從中更可學習與人相處之道。除此以外，亦讓同學參加校內外比賽，豐富同學生活體驗。最終培養終生的運動興趣，擁有一個健康的人生。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_cyc',
                    CHI: '公益少年團',
                    ENG: 'Community Youth Club',
                    Description: {
                        CHI: '公益少年團為青少年提供學校課程以外的教育，透過參與各項社區服務計劃，讓他們更認識及了解各社會問題，建立正面的個人價值觀及提高他們的公民責任感。<br /><br />公益少年團的活動範圍包括：探訪社區團體，籌劃及參與義工服務，舉辦各類型的比賽、展覽、及領袖訓練活動。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_communityAmbassador',
                    CHI: '愛心大使',
                    ENG: 'Community Ambassador',
                    Description: {
                        CHI: '類型：服務<br />對象：中一至中五<br /><br />本組透過義工服務及培訓活動，以培養學生關愛的品格及服務的技巧。<br /><br />義工服務及培訓活動例子:<br />-小學探訪<br />-義工活動訓練 / 工作坊<br />-長者送暖活動<br />-長幼日間探訪活動',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_field',
                    CHI: '田徑隊',
                    ENG: 'Field',
                    Description: {
                        CHI: '本校成立田徑校隊是為了培養學生多元發展、強身健體、磨煉意志，增強自信。田徑訓練包括長短跑和接力賽跑外，還有跳高、跳遠和擲項等項目，隊員亦會代表學校參加不同的田徑賽。田徑隊員因應不同的才能，在不同的範疇各展所長，盡力追求像奧林匹克運動會的格言「更快、更高、更強」的精神。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_flag',
                    CHI: '升旗隊',
                    ENG: 'Flag-guards',
                    Description: {
                        CHI: '升旗隊負責校內「國旗下講話」之升旗禮，並參加「香港升旗隊總會」所舉辦的課程(如:旗手護旗初級章訓練班)及專章考試(如:國家歷史章、國家知識章)，以推廣對祖國的認識，培養青年領袖。',
                        ENG: '',
                    },
                },
                { CHI: '復古遊戲學會', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_geo',
                    CHI: '地理學會',
                    ENG: 'Geographical Society',
                    Description: {
                        CHI: '本學會成立之目的為增加同學對地理科以及身邊自然及人文環境的興趣。透過實地考察、遠足、參觀及專題研習等活動，同學可從空間角度認識及理解地理現象的分布，人與環境之間的相互關係。更重要的是希望培養學生能欣賞本港獨特的地理環境及形貌，了解生態環境之脆弱，從而改變同學的生活態度。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_jpc',
                    CHI: '少年警訊',
                    ENG: 'Junior Police Call',
                    Description: {
                        CHI: '少年警訊，是香港一個以會員制度形式運作的非營利組織，為香港警務處警察公共關係科屬下的組織。<br /><br />目標：「我們鼓勵少訊會員與社會及其他組織並肩攜手撲滅罪行。培訓少訊會員具備條件成為社會未來領袖。引導少訊會員互相激勵打擊青少年罪案。」',
                        ENG: '',
                    },
                },
                { CHI: '長跑隊', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_rowing',
                    CHI: '賽艇隊',
                    ENG: 'Rowing',
                    Description: {
                        CHI: '室內賽艇艇講求良好的耐力、爆發力及意志力，缺一不可。除了個人體能水平能夠得到提升之外，更能夠培養團隊精神，提升凝聚力。時刻爭分奪秒，划出未來。本校曾有畢業生入選為港青隊員，代表香港爭光。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_tableTennis',
                    CHI: '乒乓球隊',
                    ENG: 'Table Tennis',
                    Description: {
                        CHI: '本校致力推廣乒乓球運動，於校內開設乒乓球校隊，讓隊員在常規訓練及參加各乒乓球不同比賽下，藉以提昇乒乓球的個人及雙打技術，亦促進人際溝通及團隊合作精神。',
                        ENG: '',
                    },
                },
                { CHI: '英喜茶．藝舍', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                { CHI: '旅遊學會', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_volleyball',
                    CHI: '排球隊',
                    ENG: 'Volleyball',
                    Description: {
                        CHI: '本校男女子排球校隊為對排球有興趣的學生而成立，校隊成員定期進行練習，負責老師亦安排友誼場及報名參加不同的排球比賽，讓隊員提升排球的技術，亦有助增強體魄，汲取比賽經驗，促進人際溝通、合作精神及豐富人生經歷。',
                        ENG: '',
                    },
                },
            ],
            Society: [
                { CHI: '無伴奏合唱', ENG: ''/*/////////////////////////////////////////////////////////////*/ },
                { CHI: '射箭隊', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_psychology',
                    CHI: '心理學概論',
                    ENG: 'Introduction to Psychology',
                    Description: {
                        CHI: '‘Introduction to Psychology’ is an academic club which aims to give students a brief overview on the discipline Psychology. The club mainly focuses on topics which students are interested in, such as Personality Psychology, Psychopathology, Interpersonal Relationship, Memory and Perception, etc. Activities provided range from completing Psychology tests, watching videos of classical experiments, to designing experiments to test certain hypothesis.',
                        ENG: '‘Introduction to Psychology’ is an academic club which aims to give students a brief overview on the discipline Psychology. The club mainly focuses on topics which students are interested in, such as Personality Psychology, Psychopathology, Interpersonal Relationship, Memory and Perception, etc. Activities provided range from completing Psychology tests, watching videos of classical experiments, to designing experiments to test certain hypothesis.',
                    },
                },
                {
                    ID: 'society_hourse',
                    CHI: '馬術運動及相關事業基礎認識班',
                    ENG: '',
                    Description: {
                        CHI: '同學透過認識馬匹、競技模式及相關職業工作內容，從而提升會員正向思維管理能力，並對生涯發展作規劃及準備。同學更有機會參觀馬房及體驗騎馬的樂趣。',
                        ENG: 'XXXXXXXXXXXXXX',
                    },
                },
                {
                    ID: 'society_korean',
                    CHI: '聽歌睇戲學韓文',
                    ENG: 'Korean',
                    Description: {
                        CHI: '韓國文化在香港十分流行，韓國歌曲及劇集都深受年青人歡迎。有見及此，本校於愉快星期五時段開設韓文班，鼓勵學生將個人興趣提升至語言學習。本學會透過播放最新K- pop 歌曲及大熱韓劇片段，教導學生韓文詞彙及日常會話，期望將來學生能更深入研讀韓語。',
                        ENG: '韓國文化在香港十分流行，韓國歌曲及劇集都深受年青人歡迎。有見及此，本校於愉快星期五時段開設韓文班，鼓勵學生將個人興趣提升至語言學習。本學會透過播放最新K- pop 歌曲及大熱韓劇片段，教導學生韓文詞彙及日常會話，期望將來學生能更深入研讀韓語。',
                    },
                },
                {
                    ID: 'society_boardgame',
                    CHI: '桌遊學會',
                    ENG: 'Board Game',
                    Description: {
                        CHI: '桌上遊戲歷史源遠流長，但於市場上為人熟悉的程度一直落後。直至近十年，桌上遊戲於全球的發展迅速興起，不同國家舉辦的國際級展覽亦略見規模，其發展逐漸與電子遊戲分庭抗禮。<br /><br />為讓同學初窺桌上遊戲的世界，本學會提供多種熱門的桌上遊戲，讓學員對桌上遊戲多加接觸，從而培養對桌上遊戲的興趣，訓練溝通及策略思考等技巧。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_chem',
                    CHI: '化學學會',
                    ENG: 'Chemistry',
                    Description: {
                        CHI: '化學學會的宗旨是透過有趣化學實驗活動，加強學生對高中化學科的認知及參與，從而提高同學對化學科的學習學趣及日常生活的應用。<br /><br />全年活動:<br />化學實驗示範、天然肥皂、化學式的驗證、製備醋的化學實驗、電鍍實驗、水果發電、製作不同水果氣味的酯化合物、驗證氣體的摩爾體積等。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_choir',
                    CHI: '合唱團',
                    ENG: 'Choir',
                    Description: {
                        CHI: '我們天生就有一個能創造美妙音樂的樂器—口一個。合唱團同學除了在星期五作有系統的唱歌技巧訓練外，還會於重要節日及大型活動中於校外校內表演。合唱團同學的唱歌技巧不斷進步，於學校聯演中獲獎。每年亦會有聯誼活動，如BBQ等，也有不少社區探訪活動，將音樂的美好發放出去。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_coffee',
                    CHI: '咖啡拉花學會',
                    ENG: 'Latte Art',
                    Description: {
                        CHI: '時下的中學生十分喜歡喝咖啡,經常手執一杯數十元的連鎖店咖啡。可是,關於咖啡,他們又了解多少呢?本課程希望教導學生如何品味咖啡, 認識關於咖啡的知識。我們亦會讓他們認識如何做手沖咖啡及學會拉花技巧, 並於校內實踐為活動提供咖啡服務。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_creation',
                    CHI: '藝術創作班',
                    ENG: 'Arts Creation',
                    Description: {
                        CHI: '本學會旨在透過學會幹事組織培訓學生的領導能力，協助籌備及推廣有關活動。學會亦會舉辦校外參觀、講座及工作坊等活動。讓學生在多元化的角度接觸藝術，以提升個人技巧及創造力。學生的作品更會在校園內展出，讓他們為美化校園和提升校園藝術氣氛出一分力！',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_dancing',
                    CHI: '舞蹈學會',
                    ENG: 'Dancing',
                    Description: {
                        CHI: '有留意歌星背後的舞蹈員嗎？我們跳的就是那類型的舞蹈，也就是 Jazz 和 Hip Hop。無論你有沒有跳舞經驗，只要你有心、有興趣，我們都歡迎你加入我們的舞蹈組，一起享受隨著流行音樂跳舞的樂趣。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_darts',
                    CHI: '飛鏢學會',
                    ENG: 'Darts',
                    Description: {
                        CHI: '經常玩手機都想自己設計手機遊戲?歡迎你加入手遊程式設計學會!<br /><br />你會學到手機遊戲程式開發過程，並利用App Inventor 2及Unity作"打地鼠"、"拯救遊戲"、"對戰足球遊戲"等簡單的遊戲。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_desserts',
                    CHI: '手工甜品班',
                    ENG: 'Desserts',
                    Description: {
                        CHI: '本興趣班教授多款甜品製作，如法式焦糖布甸、鳥結糖、檸檬批等，專為喜愛家政課的同學而設。除烹製甜品外，亦會教授縫製不織布甜品裝飾。希望以輕鬆形式，培養學生對家政的興趣。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_drama',
                    CHI: '話劇學會',
                    ENG: 'Drama',
                    Description: {
                        CHI: '希望發揮你的表演潛能嗎?<br />你希望試試扮演不同的角色，突破自我嗎?<br />你希望認識不同年級的朋友，感受一下團隊精神嗎?<br />歡迎你加入話劇學會大家庭，與我們一起分享演出的樂趣!',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_dubbing',
                    CHI: '配音及聲藝班',
                    ENG: 'Dubbing',
                    Description: {
                        CHI: '參與配音及聲藝班, 同學能夠了解配音行業的運作及發展, 對這行業有初步的認識。<br /><br />在課堂中, 同學不但能理解聲帶的結構, 並且學習運用聲線的方法, 例如: 丹田聲。<br /><br />透過上課練習，讓學生接受口齒訓練及不同情緒的聲音訓練。從實務配音時段中，同學能體驗配音知識、技巧和情意。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_eventManagement',
                    CHI: 'Event Management',
                    ENG: 'Event Management',
                    Description: {
                        CHI: '學生會每年均籌辦多項活動給校內同學，透過 Event Management，學生會幹事先建立團隊精神，再學習不同籌辦活動的技巧和預備。<br /><br />課程內容包括：開會技巧、籌辦活動的行政工作安排、緊急事故處理、場地佈置及管理、即興演說及評估項目效能等。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_floral',
                    CHI: '花藝班',
                    ENG: 'Floral Art',
                    Description: {
                        CHI: '花藝是「無聲的畫，立體的詩」， 旨在陶冶學生性情，提升學生的專注力，創設機會讓學生發展多元才能。同時幫助學生培養美感，建立自信，並讓他們認識一個新行業，有助其生涯規劃。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_football',
                    CHI: '足球學會',
                    ENG: 'Football',
                    Description: {
                        CHI: '推廣FIFA (International Federation of Association Football) 提出的grassroots football概念，以足球作為教育工具，使學生能享受快樂足球，亦能學習足球基本技術及規則，建立團隊精神，培養正面的人生態度。同時，這項不分年齡、性別及階層的運動，透過一連串的訓練課程及小型足球比賽，能提升同學對足球運動的興趣。足球作為團體運動，更能培養個人紀律及團隊合作精神，讓同學們突破極限，挑戰自我，成就足球夢想。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_game',
                    CHI: '遊戲學會',
                    ENG: 'Game',
                    Description: {
                        CHI: '同學在遊戲學會中以分組形式，每次嘗試接觸不同的遊戲。同學在遊戲過程中將會面對不同的遊戲規則、不同的隊友/對手，從而學會如何面對輸贏，如何嘗試與不同性格的人溝通、如何與隊友/對手合作，並且，在遊戲過程中更可放鬆心情，減低功課壓力。',
                        ENG: '',
                    },
                },
                /*{
                    ID: 'society_girlGuides',
                    CHI: '女童軍',
                    ENG: 'Girl Guides',
                    Description: {
                        CHI: '每年女童軍參與校內活動如陸運會和其他典禮的儀仗工作，我們平日除了步操訓練外，還有手工藝活動、廚藝活動和團隊訓練等等，隊員都踴躍參與。透過安排各個活動，隊長們從中學會了各種領袖技巧。',
                        ENG: '',
                    },
                },*/
                { CHI: '結他小組', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_is',
                    CHI: '創意科學學會',
                    ENG: 'Creative Science',
                    Description: {
                        CHI: '透過科學、科技及數學教育的學習活動，提升學生的學習興趣，培養學生的創造力、協作和解決問題能力，使學生具備創新思維，裝備學生，讓他們具備應有的知識、共通能力，以及價值觀和態度，並能有效地終身學習。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_japanese',
                    CHI: '日文班',
                    ENG: 'Japanese',
                    Description: {
                        CHI: '本學會由留學日本的資深老師教授，旨在教授同學從最基本的五十音開始，到簡單生活用語。<br /><br />課程的內容大致如下：<br />1) 日本語基本發音<br />2) 日常基本文法及詞語<br />3) 閱讀及寫法<br />4) 簡單生活介紹及問候用語<br />5) 介紹日本文化',
                        ENG: '',
                    },
                },
                { CHI: '聽歌睇戲學韓文', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_media',
                    CHI: '攝影及短片製作班',
                    ENG: 'Shooting and Media Creation',
                    Description: {
                        CHI: '一幅好的相片，勝過千言萬語。加入攝影學會，你可以:<br />‧學習操作不同類型相機的技巧<br />‧認識構圖和攝影角度的重要性<br />‧學習利用相片說故事<br />‧和志同道合的同學一起交流攝影心得<br />‧定期舉辦的攝影作品展，更讓同學分享攝影作品',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_mobile_app',
                    CHI: '手遊程式設計學會',
                    ENG: 'Mobile App Design',
                    Description: {
                        CHI: '經常玩手機都想自己設計手機遊戲?歡迎你加入手遊程式設計學會!<br /><br />你會學到手機遊戲程式開發過程，並利用App Inventor 2及Unity作"打地鼠"、"拯救遊戲"、"對戰足球遊戲"等簡單的遊戲。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_FilmAppreciation',
                    CHI: '電影欣賞學會',
                    ENG: 'Film Appreciation',
                    Description: {
                        CHI: '透過欣賞不同類別的電影，連結平日課堂所學知識和現實生活，更可從中感悟人生的哲理。同學亦可藉此增加對電影的欣賞分析能力。活動包括外出到電影院欣賞電影及由老師帶領反思電影內的道德價值觀。',
                        ENG: '',
                    },
                },
                {
                    ID: 'society_papercraft',
                    CHI: '紙模型班',
                    ENG: 'Papercraft',
                    Description: {
                        CHI: '隨著互聯網的普及，紙模型亦漸漸盛行。相比起一般的塑膠模型，它不但廉宜，且不用上色和粘貼容易，同學們很快就能掌握。同學們除了可以在網上下載紙模型外，亦可以自行設計自己喜歡的紙模型。<br/><br/>一張平凡的紙，可變化出各種奇妙的物件。齊來動手吧!',
                        ENG: '',
                    },
                },
                { CHI: '流行樂隊', ENG: '' /*/////////////////////////////////////////////////////////////*/ },
                {
                    ID: 'society_symphonicBand',
                    CHI: '管樂團',
                    ENG: 'Symphonic Band',
                    Description: {
                        CHI: '本校管樂團前身為步操樂隊，成立已有14年時間，是本校的珍貴寶藏。隊員會於星期五及星期二作有系統的樂器及合奏訓練，也會於特定節日及學校的大型活動中進行表演。透過樂團訓練，隊員的演奏技巧不斷提高，部分隊員亦在離校後繼續在音樂上發放異彩。',
                        ENG: '',
                    },
                },
            ],
        },
        LifeWideLearning: {
            Intro: {
                CHI: '本校舉辦「全方位學習日」，在不同級別加入重要的成長及學習元素，例如中一級學生由紀律訓練開始，以軍訓體驗建立同學良好生活習慣；中二級同學透過境外考察，以專題研習的形式，培養學生對學習的興趣，發展共通能力；中三同學透過組織及參與義工服務，培養學生服務社會及建立自信。「全方位學習日」不但能擴闊同學視野及豐富生活體驗，更能培養學生成為積極及勇於面對挑戰的新一代。',
                ENG: '',
            }
        },
        Music: {
            Intro: {
                Title: {
                    CHI: '我們的音樂活動',
                    ENG: 'Our Music Activities',
                },
                Content: {
                    CHI: [
                        '隨着本校的學生對音樂的喜愛日益增加，樂樂音樂廳（前音樂室）已經成為音樂愛好者小息、午膳、及放學的聚腳地，同學們在這裏默默地付出大量時間、汗水和心力，結果是顯而易見的。他們不單止令這個小小的音樂廳充滿美妙的音樂聲和歡樂的笑聲，這些聲音點點滴滴，有如春天的雨點，在校內活動如音樂比賽、資訊日表演、Let me Shine等表演中潤澤大地，像美麗的小鮮花在校園內綻放。他們也在校外的比賽及表演中，例如校際音樂節比賽、聯校音樂大賽、唱作願景全港中學生唱作大賽、鄰近商場和小學的聖誕報佳音活動中大放光芒，讓音樂傳遍了整個社區。',
                    ],
                    ENG: [
                        '隨着本校的學生對音樂的喜愛日益增加，樂樂音樂廳（前音樂室）已經成為音樂愛好者小息、午膳、及放學的聚腳地，同學們在這裏默默地付出大量時間、汗水和心力，結果是顯而易見的。他們不單止令這個小小的音樂廳充滿美妙的音樂聲和歡樂的笑聲，這些聲音點點滴滴，有如春天的雨點，在校內活動如音樂比賽、資訊日表演、Let me Shine等表演中潤澤大地，像美麗的小鮮花在校園內綻放。他們也在校外的比賽及表演中，例如校際音樂節比賽、聯校音樂大賽、唱作願景全港中學生唱作大賽、鄰近商場和小學的聖誕報佳音活動中大放光芒，讓音樂傳遍了整個社區。',
                    ],
                }
            }
        },
        PE: {
            Purpose: {
                Title: { CHI: '宗旨及抱負', ENG: 'Purpose and Ambition' },
                Content: {
                    CHI: [
                        '「透過身體活動進行教育」',
                        '透過讓學生參與課堂及課餘體育活動，幫助學生發展不同身體活動所需的技能，瞭解有關活動的安全知識，同時助學生培養良好健康的生活模式。',
                        '體育課堂配合新高中體育課提供多元化的學習經歷，提升學生掌握體育的知識、技能與態度，並把體育技能融入理論學習。讓他們打下良好基礎，為升讀專上教育課程做好準備。',
                    ],
                    ENG: [
                        '「透過身體活動進行教育」',
                        '透過讓學生參與課堂及課餘體育活動，幫助學生發展不同身體活動所需的技能，瞭解有關活動的安全知識，同時助學生培養良好健康的生活模式。',
                        '體育課堂配合新高中體育課提供多元化的學習經歷，提升學生掌握體育的知識、技能與態度，並把體育技能融入理論學習。讓他們打下良好基礎，為升讀專上教育課程做好準備。',
                    ],
                },
            },
            Team: {
                Title: { CHI: '體育校隊(尖子培訓)', ENG: '體育校隊(尖子培訓)' },
                Content: {
                    CHI: ['本校提供不同專項範疇的校隊培訓，助學生發掘潛能及個人強項，發展興趣，培養正面的價值觀和積極的態度，提升自信及發展協作、溝通、創造、明辨性思考和審美等共通能力，促進終身學習及全方位學習的能力。以下為校隊舉隅:'],
                    ENG: ['本校提供不同專項範疇的校隊培訓，助學生發掘潛能及個人強項，發展興趣，培養正面的價值觀和積極的態度，提升自信及發展協作、溝通、創造、明辨性思考和審美等共通能力，促進終身學習及全方位學習的能力。以下為校隊舉隅:'],
                },
                Teams: [
                    { CHI: '田徑隊', ENG: 'Track and Field Team' },
                    { CHI: '越野長跑隊', ENG: 'Cross Country Team' },
                    { CHI: '男女子乒乓球', ENG: 'Table Tennis' },
                    { CHI: '男女子羽毛球隊', ENG: 'Badminton Team' },
                    { CHI: '男女子排球隊', ENG: 'Volleyball Team' },
                    { CHI: '男女子籃球隊', ENG: 'Basketball Team' },
                    { CHI: '男子足球隊', ENG: 'Soccer Team' },
                    { CHI: '沙灘排球隊', ENG: 'Beach Volleyball Team' },
                    { CHI: '游泳隊', ENG: 'Swimming Team' },
                    { CHI: '室內賽艇隊', ENG: 'Indoor Rowing Team' },
                    { CHI: '射箭隊', ENG: 'Archery Team' },
                    { CHI: '冰球隊', ENG: 'Ice Hockey Team' },
                    { CHI: '匹克球隊 (2024-2025新增)', ENG: 'Pickleball Team (2024-2025 Added)', URL: 'https://www.pohtyh.edu.hk/%E5%B8%AB%E7%94%9F%E6%8A%95%E5%85%A5%E5%8C%B9%E5%85%8B%E7%90%83%E6%B4%BB%E5%8B%95%E8%B5%B0%E5%9C%A8%E5%9C%8B%E9%9A%9B%E6%9C%80%E5%89%8D%E7%B7%9A' },
                ],
            },
            IG: { CHI: 'TYH體育校隊', ENG: 'TYH Sports Team' },
            Links: {
                Title: { CHI: '相關網頁連結', ENG: 'Useful Website links' },
                Content: [
                    'https://www.sportsroad.hk/',
                    'https://www.lcsd.gov.hk/tc/',
                    'http://www.hkssf.org.hk/',
                ],
            },
        },
        VA: {
            Purpose: {
                Title: { CHI: '宗旨', ENG: 'Purpose' },
                Content: {
                    CHI: ['本校致力為學生提供優良的視覺藝術教育。'],
                    ENG: ['本校致力為學生提供優良的視覺藝術教育。'],
                },
                Lines: {
                    CHI: [
                        '透過視覺藝術活動，為學生提供基礎視覺藝術教育，包括：感受、審美及解讀能力等。',
                        '透過對視覺及觸覺元素的瞭解及應用，發掘學生在視覺藝術方面的潛能，並從個別指導中兼顧其個別差異，使其日後在本科有更佳的表現。',
                        '藉視覺藝術創作培養學生的思維、解難、決策和協作等能力，配合新高中課程改革。',
                        '培育學生對美育的探求，擴闊視野，從而改進自我形象及品德修養，以及生活情趣。',
                    ],
                    ENG: [
                        '透過視覺藝術活動，為學生提供基礎視覺藝術教育，包括：感受、審美及解讀能力等。',
                        '透過對視覺及觸覺元素的瞭解及應用，發掘學生在視覺藝術方面的潛能，並從個別指導中兼顧其個別差異，使其日後在本科有更佳的表現。',
                        '藉視覺藝術創作培養學生的思維、解難、決策和協作等能力，配合新高中課程改革。',
                        '培育學生對美育的探求，擴闊視野，從而改進自我形象及品德修養，以及生活情趣。',
                    ],
                },
            },
            Optimisation: {
                Title: { CHI: '視藝室優化', ENG: 'Optimisation' },
                Content: {
                    CHI: [
                        '隨著學校的不斷發展，近年來視覺藝術科的學習環境及設備亦得到進一步的優化！',
                        '優化後的視藝室，全部學生枱均設計成3人座面向前方講台，以便討論及工作。講台添置兩部電子白板，而每位學生均配備一套Ipad及apple pencil供網上搜集資料及學習電子繪圖等等之用，大大提昇了自主學習及互動的元素。除此之外，室內還設置了電腦工作區、閱讀區、大型作品展示板等；另一邊廂，室外的長廊位置是“賞悅廊”展覽區域，不時更新以分享學生的創作成果，提升了視覺藝術的學習氛圍。',
                        '整體而言，學生在優雅的學習環境中，以愉悅的心情進行創作，必定是一件賞心樂事。',
                    ],
                    ENG: [''],
                },
            },
        },
    },
    Admission: {
        Characteristics: {
            Tabs: {
                Intro: { CHI: '本校特色簡介', ENG: 'Feature Introduction', },
                Publication: { CHI: '學校年度刊物', ENG: 'Publication', },
                Video: { CHI: '學校簡介影片', ENG: 'Introduction Video', },
            },
            Tooltip: { CHI: '點擊閱覽刊物', ENG: 'Click to read the publication', },
            Intro: {
                CHI: [
                    '本校致力推行「啟發潛能教育」，由2018/2021的三年學校發展計劃開始，把其中一個關注項目訂為「適性揚才，多元發展」 (Everyone shines, given the right lighting)，到了2021/2024的三年學校發展計劃，我們再深化「啟發潛能教育」的推行，再把其中一項關注項目訂為「適異創新，閃耀潛能」(Everybody shines, just not on the same day, in the same way)。同學們努力學習之餘， 也積極參與各類活動，在學術、運動、音樂、視藝、STEAM、領袖才能、社會服務等方面， 學生都能各展所長。因此，在不同智能範疇的比賽，例如：校際朗誦節、徵文比賽、音樂比賽、各類運動比賽、藝術創作、STEAM等，都捷報頻傳。啟發潛能教育問卷的結果亦反映，本校在「地方」(Places)、「人物」(People)、「政策」(Policies)、「課程」(Programs)和「過程」(Processes)五方面的分數均有所上升。',
                    '本校繼2017 年獲得「國際啟發潛能教育聯盟」(International Alliance for Invitational Education)頒發「國際啟發潛能教育學校大獎」(Inviting School Award)、2019年獲得晉級獎項— 「國際啟發潛能教育成就大獎（一星銀獎）」(Inviting School 1st Silver Fidelity Award) 及2021年獲得「國際啟發潛能教育成就大獎（二星銀獎）」(Inviting School 2nd Silver Fidelity Award)後，又於2023年獲得第4個獎項—「國際啟發潛能教育成就大獎（三星銀獎）」(Inviting School 3rd Silver Fidelity Award)。',
                    '我們的信念是每個孩子都是珍貴的，他們有自己獨特的潛能和成功的能力。所以，本校以美國哈佛大學 哈沃德．加德納教授(Dr.Howard Gardner)提出的「多元智能」Multiple Intelligence 框架建立「校本人才庫」，加強普及潛能以及精英潛能教育，藉此協助發掘及發揮學生潛能，以達到「適性揚才，多元發展」的目標。',
                    '九大智能包括：語言、邏輯數學、空間、身體動覺、音樂、人際關係、內省、自然辨識、存在。',
                    '我們全校一心，以愛陪伴，用掌聲支持，助同學在各自綻放異彩、發展所長。',
                ],
                ENG: [
                    '本校致力推行「啟發潛能教育」，由2018/2021的三年學校發展計劃開始，把其中一個關注項目訂為「適性揚才，多元發展」 (Everyone shines, given the right lighting)，到了2021/2024的三年學校發展計劃，我們再深化「啟發潛能教育」的推行，再把其中一項關注項目訂為「適異創新，閃耀潛能」(Everybody shines, just not on the same day, in the same way)。同學們努力學習之餘， 也積極參與各類活動，在學術、運動、音樂、視藝、STEAM、領袖才能、社會服務等方面， 學生都能各展所長。因此，在不同智能範疇的比賽，例如：校際朗誦節、徵文比賽、音樂比賽、各類運動比賽、藝術創作、STEAM等，都捷報頻傳。啟發潛能教育問卷的結果亦反映，本校在「地方」(Places)、「人物」(People)、「政策」(Policies)、「課程」(Programs)和「過程」(Processes)五方面的分數均有所上升。',
                    '本校繼2017 年獲得「國際啟發潛能教育聯盟」(International Alliance for Invitational Education)頒發「國際啟發潛能教育學校大獎」(Inviting School Award)、2019年獲得晉級獎項— 「國際啟發潛能教育成就大獎（一星銀獎）」(Inviting School 1st Silver Fidelity Award) 及2021年獲得「國際啟發潛能教育成就大獎（二星銀獎）」(Inviting School 2nd Silver Fidelity Award)後，又於2023年獲得第4個獎項—「國際啟發潛能教育成就大獎（三星銀獎）」(Inviting School 3rd Silver Fidelity Award)。',
                    '我們的信念是每個孩子都是珍貴的，他們有自己獨特的潛能和成功的能力。所以，本校以美國哈佛大學 哈沃德．加德納教授(Dr.Howard Gardner)提出的「多元智能」Multiple Intelligence 框架建立「校本人才庫」，加強普及潛能以及精英潛能教育，藉此協助發掘及發揮學生潛能，以達到「適性揚才，多元發展」的目標。',
                    '九大智能包括：語言、邏輯數學、空間、身體動覺、音樂、人際關係、內省、自然辨識、存在。',
                    '我們全校一心，以愛陪伴，用掌聲支持，助同學在各自綻放異彩、發展所長。',
                ],
            },
            DomainTitle: {
                A: { CHI: '語言', ENG: 'Verbal-Linguistic' },
                B: { CHI: '邏輯數理', ENG: 'Mathematical-Logical' },
                C: { CHI: '空間', ENG: 'Visual-Spatial' },
                D: { CHI: '身體動覺', ENG: 'Bodily-Kinesthetic)' },
                E: { CHI: '音樂', ENG: 'Musical' },
                F: { CHI: '人際關係', ENG: 'Interpersonal' },
                G: { CHI: '內省', ENG: 'Intrapersonal' },
                H: { CHI: '自然辨識', ENG: 'Naturalist' },
                I: { CHI: '存在', ENG: 'Existential' },
            },
            DisplayModel: { CHI: '校本人才庫數據展示模式', ENG: 'School-based talent pool data display model' },
        },
        S1Admission: {
            Intro: {
                CHI: '2027年9月入讀中一<br />以下行事曆只適用於申請官立、資助及按位津貼中學及參加中學學位分配辦法的直接資助計劃中學。',
                ENG: '2027年9月入讀中一<br />以下行事曆只適用於申請官立、資助及按位津貼中學及參加中學學位分配辦法的直接資助計劃中學。',
            },
            SSPATitle: { CHI: '學位分配行事曆', ENG: 'Schedule of Secondary School Places Allocation (SSPA) System' },
            DateTitle: { CHI: '日期', ENG: 'Date' },
            ScheduleTitle: { CHI: '日程', ENG: 'Schedule' },
            Schedule: [
                {
                    Date: '5/12/2026',
                    Schedule: { CHI: '2027-2028學年升中資訊日', ENG: 'Secondary One (2027-2028) Admission Talk' }
                },
                {
                    Date: '1/12/2026-18/1/2027',
                    Schedule: { CHI: '派發中一自行分配學位申請表格', ENG: 'Distribution of Application Forms for S.1 Discretionary Places' }
                },
                {
                    Date: '4-18/1/2027',
                    Schedule: { CHI: '遞交中一自行分配學位申請表格(紙本/電子平台)', ENG: 'Submission of Application Forms for S.1 Discretionary Places(Paper form/SSPA e-Platform)' }
                },
                {
                    Date: '6/3/2027',
                    Schedule: { CHI: '自行分配學位申請學生面試', ENG: 'Interview with the Shortlisted Applicants for Discretionary Place Application' }
                },
                {
                    Date: '31/3/2027',
                    Schedule: { CHI: '學校通知所有正取學生的家長/監護人獲得自行分配學位正取學生名單', ENG: 'Notify Parents/Guardian of Successful SSPA Applicants of Discretionary Places' }
                },
                {
                    Date: '2027年4月上旬至5月上旬 Early April - Early May 2027',
                    Schedule: { CHI: '統一派位選校日期', ENG: 'Central Allocation Choice-making period' }
                },
                {
                    Date: '6/7/2027',
                    Schedule: { CHI: '教育局發放小六升中一派位結果', ENG: 'Release of Discretionary Places and Central Allocation Results' }
                },
                {
                    Date: '6-9/7/2027',
                    Schedule: { CHI: '中一叩門學位申請', ENG: 'Application for Secondary One Places after Release of SSPA Result' }
                },
                {
                    Date: '8-9/7/2027',
                    Schedule: { CHI: '中一註冊', ENG: 'Secondary One Registration' }
                },
                {
                    Date: '13/7/2027',
                    Schedule: { CHI: '中一入學前學科測驗', ENG: 'Pre-Secondary One Hong Kong Attainment Test' }
                },

            ],
            More: {
                CHI: '<p>如想了解更多，可<a style="text-decoration: underline;" href="https://www.edb.gov.hk/tc/edu-system/primary-secondary/spa-systems/secondary-spa/general-info/" target="_blank">按此</a>參閱教育局網頁</p>',
                ENG: ''
            },
        },
        S1Application: {
            Document: {
                Title: { CHI: '文件下載', ENG: 'Document' },
                Documents: [
                    {
                        CHI: '2025-2026自行分配中一學位申請須知',
                        ENG: '2025-2026自行分配中一學位申請須知',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/2025-2026自行分配中一學位申請須知_中英合拼版.pdf',
                    },
                    {
                        CHI: '2025-2026自行分配中一學位申請表格',
                        ENG: '2025-2026自行分配中一學位申請表格',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/2025-2026自行分配中一學位申請表格.pdf',
                    },
                ],
            }
        },
        S1Registration: {
            Document: {
                Title: { CHI: '文件下載', ENG: 'Document' },
                Documents: [
                    /*{
                        CHI: '2026-2027自行分配中一學位申請表格',
                        ENG: '2026-2027自行分配中一學位申請表格',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/2026-2027自行分配中一學位申請表格.pdf',
                    },
                    {
                        CHI: '2026-2027自行分配中一學位申請須知',
                        ENG: '2026-2027自行分配中一學位申請須知',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/2026-2027自行分配中一學位申請須知.pdf',
                    },*/
                    {
                        CHI: '中一註冊須知(2026-2027)',
                        ENG: '中一註冊須知(2026-2027)',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/中一註冊須知(2026-2027).pdf',
                    },
                    {
                        CHI: '中一叩門須知(2026-2027)',
                        ENG: '中一叩門須知(2026-2027)',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/中一叩門須知(2026-2027).pdf',
                    },
                    {
                        CHI: '中一叩門表格(2026-2027)',
                        ENG: '中一叩門表格(2026-2027)',
                        URL: 'https://www.pohtyh.edu.hk/Files/S1Application/中一叩門表格(2026-2027).pdf',
                    },
                ],
            }
        },
    },
    Alumni: {
        Title: { CHI: '校友會', ENG: 'Alumni Association' },
        AboutUs: {
            Title: { CHI: '本會宗旨', ENG: '本會宗旨' },
            Content: [
                { Title: '支持學校發展', Text: '通過校友的資源和經驗，支持學校的學術、設施和課外活動發展，提升學校的整體水平。', },
                { Title: '促進校友與學校的互動', Text: '定期舉辦校友活動，如聚會和工作坊，以及邀請校友參與學校活動，讓校友與學校保持緊密聯繫。', },
                { Title: '傳承學校精神與文化', Text: '通過校友會活動以及邀請校友回校分享，傳承學校的價值觀、傳統和文化，增強校友和在校學生對學校的歸屬感。', },
                { Title: '促進跨代交流', Text: '強化校友網絡的建構，搭建不同年代校友，乃至於與在校學生之間的交流平台，分享經驗和資源，促進彼此成長。', },
            ],
        },
        RoleTitle: { CHI: '校友會各幹事資料', ENG: 'Information of the Alumni Association' },
        Role: {
            Chairman: { CHI: '主席', ENG: 'Chairman' },
            ViceChairmanForeign: { CHI: '外務副主席', ENG: 'Vice Chairman' },
            ViceChairmanInternal: { CHI: '內務副主席', ENG: 'Vice Chairman' },
            Secretary: { CHI: '幹事', ENG: 'Secretary' },
        },
        ContactTitle: { CHI: '聯絡我們', ENG: 'Contact Us' },
        ContactContent: {
            CHI: '欲獲取有關校友會的資料，請聯絡主席:',
            ENG: 'For information about the Alumni Association, please contact the chairman:',
        },
    },
    CampusDevelopment: {
        ACE: {
            Intro: {
                CHI: ['隨着近年健體風氣盛行，前往健身室鍛鍊身體已成為擁有強健體魄的不二法門。本校透過改建有蓋雨天操場成為體適能中心，冀加強全校同學對體適能的認識，幫助同學們建立健康的生活方式。中心設有多款健身器材，讓同學能在日常參與不同訓練，建立健康生活習慣。此外，中心更能為體育校隊成員和修讀中學文憑試體育科的同學提供專項訓練，提升學生運動表現，爭取更佳成績。最後我們決定將體適能中心命名為 “ACE FITNESS CENTRE”。“ACE”可解作優秀及卓越的意思，而當中含意可解作 “Act Confidently for Excellence”，藉此希望同學能夠做任何事情時也要「充滿信心，追求卓越」。'],
                ENG: ['隨着近年健體風氣盛行，前往健身室鍛鍊身體已成為擁有強健體魄的不二法門。本校透過改建有蓋雨天操場成為體適能中心，冀加強全校同學對體適能的認識，幫助同學們建立健康的生活方式。中心設有多款健身器材，讓同學能在日常參與不同訓練，建立健康生活習慣。此外，中心更能為體育校隊成員和修讀中學文憑試體育科的同學提供專項訓練，提升學生運動表現，爭取更佳成績。最後我們決定將體適能中心命名為 “ACE FITNESS CENTRE”。“ACE”可解作優秀及卓越的意思，而當中含意可解作 “Act Confidently for Excellence”，藉此希望同學能夠做任何事情時也要「充滿信心，追求卓越」。'],
            },
            Section: {
                CHI: ['ACE FITNESS CENTRE劃分為以下四個區域：'],
                ENG: ['ACE FITNESS CENTRE劃分為以下四個區域：'],
            },
            Aerobic: {
                Title: { CHI: '有氧訓練區', ENG: '有氧訓練區' },
                Content: {
                    CHI: [
                        '有氧運動除了能夠燃燒脂肪，還可以保持良好的心肺功能，維持人體的基本健康。體適能中心設有6部划艇機及5部磁阻智能單車機。划艇機能刺激到大部分主要肌肉群，同時結合肌力與有氧訓練效果。磁阻智能單車機能夠追蹤使用者心率、卡路里等，這些資訊直接顯示在自行車的控制台上，配合電子LED WALL，與同學進行互動式訓練，結合音樂、視覺效果和運動數據，激勵運動動機。',
                    ],
                    ENG: [
                        '有氧運動除了能夠燃燒脂肪，還可以保持良好的心肺功能，維持人體的基本健康。體適能中心設有6部划艇機及5部磁阻智能單車機。划艇機能刺激到大部分主要肌肉群，同時結合肌力與有氧訓練效果。磁阻智能單車機能夠追蹤使用者心率、卡路里等，這些資訊直接顯示在自行車的控制台上，配合電子LED WALL，與同學進行互動式訓練，結合音樂、視覺效果和運動數據，激勵運動動機。',
                    ],
                },
            },
            FreeWeights: {
                Title: { CHI: '自由重量訓練區', ENG: '自由重量訓練區' },
                Content: {
                    CHI: [
                        '該訓練區包括史密夫訓練機、槓鈴深蹲架、啞鈴、藥球等訓練器械。當中自由重量的訓練可以給予身體較多不同的刺激，包括：神經系統、協同肌群、身體感覺、平衡感等，有助提升運動的能力。',
                    ],
                    ENG: [
                        '該訓練區包括史密夫訓練機、槓鈴深蹲架、啞鈴、藥球等訓練器械。當中自由重量的訓練可以給予身體較多不同的刺激，包括：神經系統、協同肌群、身體感覺、平衡感等，有助提升運動的能力。',
                    ],
                },
            },
            Equipment: {
                Title: { CHI: '器械訓練區', ENG: '器械訓練區' },
                Content: {
                    CHI: [
                        '本區設有大腿推蹬訓練機、大腿伸展及屈曲訓練機、臂屈伸及引體上升輔助訓練器、滑輪下拉及多功能滑索訓練機。機械式器材特點就是有固定範圍、移動軌道，幫助關節穩定，比較能對特定肌肉作集中訓練，維持肌肉張力，而且訓練時亦較安全及具有針對性，提升上肢及下肢的肌肉量。',
                    ],
                    ENG: [
                        '本區設有大腿推蹬訓練機、大腿伸展及屈曲訓練機、臂屈伸及引體上升輔助訓練器、滑輪下拉及多功能滑索訓練機。機械式器材特點就是有固定範圍、移動軌道，幫助關節穩定，比較能對特定肌肉作集中訓練，維持肌肉張力，而且訓練時亦較安全及具有針對性，提升上肢及下肢的肌肉量。',
                    ],
                },
            },
            Functional: {
                Title: { CHI: '功能性訓練區', ENG: '功能性訓練區' },
                Content: {
                    CHI: [
                        '功能性訓練目的是強化日常生活及運動的能力，讓肌肉發揮功能，而不是分隔開來單一訓練。當中包括多功能軟式增強訓練箱、懸吊式阻抗訓練 (TRX)、Skilltools技能工具套件等。不同訓練工具能夠針對個人身體特質，全面強化肌力、速度、爆發力等等，全面提升健康及競技運動體適能的能力。',
                    ],
                    ENG: [
                        '功能性訓練目的是強化日常生活及運動的能力，讓肌肉發揮功能，而不是分隔開來單一訓練。當中包括多功能軟式增強訓練箱、懸吊式阻抗訓練 (TRX)、Skilltools技能工具套件等。不同訓練工具能夠針對個人身體特質，全面強化肌力、速度、爆發力等等，全面提升健康及競技運動體適能的能力。',
                    ],
                },
            },
            Other: {
                Content: {
                    CHI: [
                        '此外，體適能中心盼能將運動科技數據化，對同學身體作出多方面監測及作出評估，有效讓同學達到訓練目標。學校同時亦會提供一些電子儀器，如身體分析儀、訓練用反應燈、心跳帶、訓練平台軟件等等，讓同學更了解自己身體，全面提升學生的體能和自信心，從而鼓勵同學們訂立更高更遠的目標。',
                        '最後希望同學坐直、喝水、讀書、做運動，更加要照顧好自己。',
                    ],
                    ENG: [
                        '此外，體適能中心盼能將運動科技數據化，對同學身體作出多方面監測及作出評估，有效讓同學達到訓練目標。學校同時亦會提供一些電子儀器，如身體分析儀、訓練用反應燈、心跳帶、訓練平台軟件等等，讓同學更了解自己身體，全面提升學生的體能和自信心，從而鼓勵同學們訂立更高更遠的目標。',
                        '最後希望同學坐直、喝水、讀書、做運動，更加要照顧好自己。',
                    ],
                },
            },
        },
        BlessedBotanicals: {
            EBook: {
                Title: { CHI: '貽園誌', ENG: 'EBook', },
                Description: {
                    CHI: '由種植小組同學主導的《貽園誌》，透過鏡頭與文字記錄貽園的點滴。從播種到收成，學生親身參與攝影與撰寫，捕捉植物生長的奧妙時刻，以及分享成果的喜悅。它不僅是園藝成果的展現，更承載同學們的學習軌跡與自然感悟，見證貽園從無到有的綠色奇蹟。邀請您一同翻閱，感受這片土地的生命力！',
                    ENG: '由種植小組同學主導的《貽園誌》，透過鏡頭與文字記錄貽園的點滴。從播種到收成，學生親身參與攝影與撰寫，捕捉植物生長的奧妙時刻，以及分享成果的喜悅。它不僅是園藝成果的展現，更承載同學們的學習軌跡與自然感悟，見證貽園從無到有的綠色奇蹟。邀請您一同翻閱，感受這片土地的生命力！',
                },
                ClickPage: { CHI: '點擊以上圖片可翻頁閱覽!', ENG: '點擊以上圖片可翻頁閱覽!', },
                KeepUpdate: { CHI: '持續更新!', ENG: '持續更新!', },
                ViewFullscreen: { CHI: '打開貽園誌', ENG: '打開貽園誌', },
                SwipeLeft: { CHI: '向左掃翻閱下一頁', ENG: 'Swipe left to read next page', },
            },
            Garden: {
                Title: { CHI: '我們的植物', ENG: 'Our Plants', },
            },
            Knowledge: {
                Title: { CHI: '貽園小知識', ENG: 'Knowledge', },
            },
            Activities: {
                Title: { CHI: '活動剪影', ENG: 'Activities', },
            },
            Timelapse: {
                Title: { CHI: '縮時攝影', ENG: 'Timelapse', },
            },
        },
        CafeGeographie: {
            Intro: {
                CHI: ['隨着新時代學習環境的不斷轉變，地理室變新成一個結合地理教學及咖啡廳兩個主題元素的“Café Géographie” 。'],
                ENG: ['隨着新時代學習環境的不斷轉變，地理室變新成一個結合地理教學及咖啡廳兩個主題元素的“Café Géographie” 。'],
            },
            Cafe: {
                Title: { CHI: '咖啡廳', ENG: 'Café' },
                Content: {
                    CHI: [
                        '這個部份主要分為煮食區及餐飲區。同學可以在校內一個真正的咖啡廳環境下學習沖調咖啡，不是一件很美妙的事嗎？我們的咖啡廳配備不同種類的咖啡工具：半自動式咖啡機、磨豆器、調製虹吸式及滴漏咖啡的儀器，務求讓同學在學習沖調咖啡時，有豐富及置身現實環境的體驗。',
                        '用餐區選用深木色長枱，旁邊的牆身將會投射虛擬的雨林影像及聲音，令同學有如置身熱帶雨林，細嚐咖啡，何其愜意!',
                    ],
                    ENG: [
                        '這個部份主要分為煮食區及餐飲區。同學可以在校內一個真正的咖啡廳環境下學習沖調咖啡，不是一件很美妙的事嗎？我們的咖啡廳配備不同種類的咖啡工具：半自動式咖啡機、磨豆器、調製虹吸式及滴漏咖啡的儀器，務求讓同學在學習沖調咖啡時，有豐富及置身現實環境的體驗。',
                        '用餐區選用深木色長枱，旁邊的牆身將會投射虛擬的雨林影像及聲音，令同學有如置身熱帶雨林，細嚐咖啡，何其愜意!',
                    ],
                },
            },
            SelfDirectedLearning: {
                Title: { CHI: '自主學習區', ENG: 'Self-directed Learning Area' },
                Content: {
                    CHI: [
                        '除了日常的教學用途外，Café Géographie 將會於午膳及放學時間開放給同學作地理學習。學生枱以小組形式配置，方便小組討論。同學如果希望獨自溫習，以及想擁有一個開闊的視野，就可以選擇窗邊的長枱。當同學溫習久了，抬頭遠望窗外的景色，相信溫習效能必可提升。長枱亦配備了多部iPad，供同學作資料搜集或自主學習之用。',
                    ],
                    ENG: [
                        '除了日常的教學用途外，Café Géographie 將會於午膳及放學時間開放給同學作地理學習。學生枱以小組形式配置，方便小組討論。同學如果希望獨自溫習，以及想擁有一個開闊的視野，就可以選擇窗邊的長枱。當同學溫習久了，抬頭遠望窗外的景色，相信溫習效能必可提升。長枱亦配備了多部iPad，供同學作資料搜集或自主學習之用。',
                    ],
                },
            },
            Geography: {
                Title: { CHI: '地理教學區：智能沙箱(Sandbox)新體驗', ENG: 'Geography Teaching Area: New Experience of Intelligent Sandbox' },
                Content: {
                    CHI: [
                        '地理教學上，有一些課題相對比較抽象，例如河流及地圖閱讀，學生往往難以真正理解實際環境及抽象概念。本校引入了運用「擴增實境Augmented Reality (簡稱AR) 」技術的教學工具—— 智能沙箱。當我們移動沙粒時，投射的影像(即等高線圖)也會隨之而改變。最有趣的互動，莫過於當我們伸出手掌時，投射的影像便會出現模擬降雨的情況，這無疑會增加我們對學習河流等課題的興趣及了解。',
                    ],
                    ENG: [
                        '地理教學上，有一些課題相對比較抽象，例如河流及地圖閱讀，學生往往難以真正理解實際環境及抽象概念。本校引入了運用「擴增實境Augmented Reality (簡稱AR) 」技術的教學工具—— 智能沙箱。當我們移動沙粒時，投射的影像(即等高線圖)也會隨之而改變。最有趣的互動，莫過於當我們伸出手掌時，投射的影像便會出現模擬降雨的情況，這無疑會增加我們對學習河流等課題的興趣及了解。',
                    ],
                },
            },
        },
        CarbonFootprint: {
            Content: {
                CHI: '<p>我們每次開啟電器、駕駛汽車或乘坐飛機，均會產生溫室氣體，這便是所謂的「碳足印」。「碳足印」是以我們進行活動時產生的溫室氣體量作為計算單位，來評估環境所受的影響。許多機構已制訂估算碳足跡的工具，並建議適用於削減溫室氣體排放的措施。</p><p>要了解更多，可瀏覽：</p><ul type="disc"><li><a href="http://www.climatechange.hk/cht/index.aspx" target="_blank">「噸噸愛地球」計算機</a></li><li><a href="http://www.ghgprotocol.org/" target="_blank">溫室氣體議定書</a>為公司建立其溫室氣體排放清單的<a href="http://www.ghgprotocol.org/calculation-tools" target="_blank">計算工具</a>(只有英文)</li><li>碳中和<a href="https://www.carboncalculator.gov.hk/tc" target="_blank">低碳生活計算機</a> </li><li>港燈電力投資有限公司的<a href="https://www.hkelectric.com/zh/customer-services/billing-payment-and-tariffs/carbon-calculator" target="_blank">碳排放計算器</a> </li></ul><p>大家齊來實踐綠色生活！<br />可瀏覽：</p><ul type="disc"><li><a href="http://www.epd.gov.hk/epd/tc_chi/climate_change/indiv_actions_tips.html">減少溫室氣體的要訣</a></li><li><a href="http://www.epd.gov.hk/epd/tc_chi/climate_change/hkactions.html">香港採取的行動</a></li></ul>',
                ENG: '',
            }
        },
        Environmental: {
            BackgroundTitle: { CHI: '背景', ENG: 'Background', },
            BackgroundContent: {
                CHI: [
                    '本校為一所接受政府資助的學校，所用的資源，都是取諸市民大眾，亦來自地球上珍貴的資源，因此必須由教職員及學生攜手合作，採取各種善用資源的方法，避免浪費，改善環境及為我們的下一代實踐可持續發展。',
                    '此外，辦學團體博愛醫院亦於未來實踐「邁向綠色機構」計劃，本校會藉此機遇，透過本環境政策及相關措施，實踐及推動環保教育，使鄧英喜中學成為一所綠色學校。',
                ],
                ENG: [
                    '本校為一所接受政府資助的學校，所用的資源，都是取諸市民大眾，亦來自地球上珍貴的資源，因此必須由教職員及學生攜手合作，採取各種善用資源的方法，避免浪費，改善環境及為我們的下一代實踐可持續發展。',
                    '此外，辦學團體博愛醫院亦於未來實踐「邁向綠色機構」計劃，本校會藉此機遇，透過本環境政策及相關措施，實踐及推動環保教育，使鄧英喜中學成為一所綠色學校。',
                ],
            },
            MissionTitle: { CHI: '使命', ENG: 'Mission', },
            MissionContent: {
                CHI: ['本校將盡力提倡及實踐環保，透過各項環境管理實務及教育活動，加強全校教職員及學生的環保意識、培養支持環保的態度，並實踐綠色生活。'],
                ENG: '',
            },
            StrategiesTitle: { CHI: '策略及措施', ENG: 'Strategies and Measures', },
            StrategiesContent: {
                CHI: [
                    '校務發展委員會擬定下列《環境政策聲明》及《實務守則》，並經全體教職員及家長的諮詢，由全校教職員及學生協力落實。',
                    '此外，校務發展委員會參考《綠色學校獎自我評核手冊》內的指標，以及根據相關法例規定，制訂學校的環境政策中長期發展項目及措施，並與相關的委員會協力執行及檢討(每年)，致力使學校成為一所獲獎項嘉許及肯定的綠色學校。',
                ],
                ENG: '',
            },
            StatementTitle: { CHI: '環境政策聲明', ENG: 'Environmental Policy Statement', },
            StatementContent: {
                CHI: ['我們共同承諾'],
                ENG: '',
            },
            StatementContentList: {
                CHI: [
                    '遵守所有環保法例',
                    '改善學校環境建設、綠化校園',
                    '保護環境: 減少製造廢物及污染物、保持清潔',
                    '珍惜資源: 節約能源、節約用水、節約用紙',
                    '實踐4R: 減少使用(Reduce)、 廢物利用(Re-use)、循環再造(Recycle)、替代使用(Replace)',
                    '推動可持續發展應用',
                    '積極參與生態及環境教育活動',
                    '致力向校內及社區人士宣傳環保訊息',
                ],
                ENG: '',
            },
            PracticeTitle: { CHI: '環境政策聲明', ENG: 'Codes of Practice', },
            Practice: {
                Content: {
                    Student: {
                        CHI: ['環境管理學生守則'],
                        ENG: '',
                    },
                    Staff: {
                        CHI: ['環境管理教職員守則'],
                        ENG: '',
                    },
                },
                List: {
                    Student: {
                        CHI: [
                            '減廢政策',
                            [
                                '每一個班房均設廢紙回收箱，學生必須將所有廢紙放進回收箱。',
                                '學生應於佈置班房時廢物利用或循環再用，避免浪費金錢及產生廢物。',
                                '學生應即日將派發的報紙及雜誌帶回家中。',
                                '使用環保袋。',
                                '自備水樽盛水。',
                                '學生必須自備食具和使用可再用餐具，減少使用即棄餐具。',
                                '善用各類回收箱， 例如：',
                                [
                                    '班房廢紙回收箱： 書本、刊物、文件等應除去釘裝膠環、文件夾及塑膠包裝後才放進回收箱內；',
                                    '三色分類回收箱: 設置於有蓋操場，收集鋁罐、膠樽及廢紙；',
                                    '墨盒回收箱: 設置於有蓋操場，回收用完的打印機墨盒'
                                ],

                            ],
                            '除教職員批准外，學生不可擅自取用粉筆。',
                            '盡量重用舊學校文件夾，減少浪費',
                            '節約用水',
                            [
                                '善用飲水器，每次只盛需要的容量。'
                            ],
                            '節約能源',
                            '如課室長時間無人使用，應關掉所有電源。',
                            '當日天文台公布的最高氣溫為20度或以下，除非校舍外有因工程而產生之過量噪音，課室暫停開放冷氣，並開啟窗戶，校方並會將冷氣開關總掣關上。',
                            '不應自行開關冷氣。',
                            '在氣溫高或陽光猛烈的情況下，應放下百葉簾或窗簾，減低室內溫度。',
                            '珍惜校園設施',
                            '愛護和善用校園內的設施，積極參與課室管理計劃。',
                            '多觀察及欣賞校園植物，並透過植物標籤增加對植物的認識。',
                            '環保活動',
                            '應積極參與校內及校外的環保或生態的活動。',
                            '應積響應各環保日，例如地球一小時、無膠樽日、無冷氣日。',
                        ],
                        ENG: '',
                    },
                    Staff: {
                        CHI: [
                            '減廢政策',
                            [
                                '請將只用單面的完好A4白紙放到單面紙的回收箱內，使電腦打印機可作重用。',
                                '如作單面電腦打印，盡量選用環保紙列印機。',
                                '請將廢紙放到教員室或校務處的回收箱內。',
                                '請不時提醒學生將廢紙投進班房的廢紙回收箱內。',
                                '請不時提醒學生即日將報紙帶回家中，避免於班房內積聚大量報紙。',
                                '鼓勵學生於佈置班房時廢物利用，避免浪費金錢及產生更多廢物。',
                                '鼓勵學生盡量重用舊學校文件夾，減少浪費',
                                '校務處設公文袋回收箱，請盡量使用回收用後的公文袋或信封。',
                            ],
                            '節約用水',
                            '用水後必須將水龍頭關好。',
                            '節約能源',
                            [
                                '如課室於隨後一節或以上無人使用，請老師關掉所有電源: 冷氣、電燈、抽氣扇、風扇。',
                                '根據天文台之天氣預報，如當天早上最高氣溫為20°C 以上，才會開啟課室內之冷氣。',
                                '在冷氣開啓時，關上門窗，減少冷氣流失。',
                                '在氣溫高或陽光猛烈的情況下，提醒學生放下百葉簾或窗簾，減低室內溫度。',
                                '若教員室或校務處的教職員不多(例如在周六或正常辦公時間外)，應將部分電燈及冷氣關上。',
                                '電腦及手提電腦已被設定成休眠模式或備用模式，如長時間不用(如放工後)，請將手提電腦蓋上，或把電腦關上。',
                                '上落一兩樓層時應盡量行樓梯，而非乘搭升降機，健康又省電。',
                            ],
                            '環保採購指引',
                            '如電器有機電署的能源效益標籤，會只選購更省電的第1級或第2級的產品。',
                            '只選購更省電的LED顯示器。',
                            '在更換光管或燈泡時，只選購慳電膽或節能光管(例如T5光管)，逐漸取替現有的非慳電光管類別。',
                            '選購補充裝的消耗性物品， 例如原子筆、梘液、洗潔精及打蠟水。',
                            '選購生物可降解的殺蟲劑， 減低對生態環境的破壞。',
                            '選購生物可降解的垃圾膠袋， 減低對生態環境的破壞。',
                        ],
                        ENG: '',
                    },
                },
            },
            PracticeContent_BAK: {
                CHI: '<p><u>環境管理學生守則</u></p><ul><li>減廢政策</li><ul><li>每一個班房均設廢紙回收箱，學生必須將所有廢紙放進回收箱。</li><li>學生應於佈置班房時廢物利用或循環再用，避免浪費金錢及產生廢物。</li><li>學生應即日將派發的報紙及雜誌帶回家中。</li><li>使用環保袋。</li><li>自備水樽盛水。</li><li>學生必須自備食具和使用可再用餐具，減少使用即棄餐具。</li><li>善用各類回收箱， 例如：</li><ul><li>班房廢紙回收箱： 書本、刊物、文件等應除去釘裝膠環、文件夾及塑膠包裝後才放進回收箱內；</li><li>三色分類回收箱: 設置於有蓋操場，收集鋁罐、膠樽及廢紙；</li><li>墨盒回收箱: 設置於有蓋操場，回收用完的打印機墨盒</li></ul></ul><li>除教職員批准外，學生不可擅自取用粉筆。</li><li>盡量重用舊學校文件夾，減少浪費</li><li>節約用水</li><ul><li>善用飲水器，每次只盛需要的容量。</li></ul><li>節約能源</li><li>如課室長時間無人使用，應關掉所有電源。</li><li>當日天文台公布的最高氣溫為20度或以下，除非校舍外有因工程而產生之過量噪音，課室暫停開放冷氣，並開啟窗戶，校方並會將冷氣開關總掣關上。</li><li>不應自行開關冷氣。</li><li>在氣溫高或陽光猛烈的情況下，應放下百葉簾或窗簾，減低室內溫度。</li><li>珍惜校園設施</li><li>愛護和善用校園內的設施，積極參與課室管理計劃。</li><li>多觀察及欣賞校園植物，並透過植物標籤增加對植物的認識。</li><li>環保活動</li><li>應積極參與校內及校外的環保或生態的活動。</li><li>應積響應各環保日，例如地球一小時、無膠樽日、無冷氣日。</li></ul><p><u>環境管理教職員守則</u></p><ul><li>減廢政策</li><ul><li>請將只用單面的完好A4白紙放到單面紙的回收箱內，使電腦打印機可作重用。</li><li>如作單面電腦打印，盡量選用環保紙列印機。</li><li>請將廢紙放到教員室或校務處的回收箱內。</li><li>請不時提醒學生將廢紙投進班房的廢紙回收箱內。</li><li>請不時提醒學生即日將報紙帶回家中，避免於班房內積聚大量報紙。</li><li>鼓勵學生於佈置班房時廢物利用，避免浪費金錢及產生更多廢物。</li><li>鼓勵學生盡量重用舊學校文件夾，減少浪費</li><li>校務處設公文袋回收箱，請盡量使用回收用後的公文袋或信封。</li></ul><li>節約用水</li><li>用水後必須將水龍頭關好。</li><li>節約能源</li><ul><li>如課室於隨後一節或以上無人使用，請老師關掉所有電源: 冷氣、電燈、抽氣扇、風扇。</li><li>根據天文台之天氣預報，如當天早上最高氣溫為20°C 以上，才會開啟課室內之冷氣。</li><li>在冷氣開啓時，關上門窗，減少冷氣流失。</li><li>在氣溫高或陽光猛烈的情況下，提醒學生放下百葉簾或窗簾，減低室內溫度。</li><li>若教員室或校務處的教職員不多(例如在周六或正常辦公時間外)，應將部分電燈及冷氣關上。</li><li>電腦及手提電腦已被設定成休眠模式或備用模式，如長時間不用(如放工後)，請將手提電腦蓋上，或把電腦關上。</li><li>上落一兩樓層時應盡量行樓梯，而非乘搭升降機，健康又省電。</li></ul></ul><ul><li>環保採購指引</li><li>如電器有機電署的能源效益標籤，會只選購更省電的第1級或第2級的產品。</li><li>只選購更省電的LED顯示器。</li><li>在更換光管或燈泡時，只選購慳電膽或節能光管(例如T5光管)，逐漸取替現有的非慳電光管類別。</li><li>選購補充裝的消耗性物品， 例如原子筆、梘液、洗潔精及打蠟水。</li><li>選購生物可降解的殺蟲劑， 減低對生態環境的破壞。</li><li>選購生物可降解的垃圾膠袋， 減低對生態環境的破壞。</li></ul>',
                ENG: '',
            },
            DailyTitle: { CHI: '已運作之日常環保措施', ENG: 'Daily Environmental Protection Measures', },
            DailyContent: {
                CHI: [
                    '以幼身光管(T5 光管)取代粗身光管(T8 光管) 。',
                    '升降機已設置為省電的休眠模式。',
                    '所有電腦均設有休眠模式，或定時開機之設置。',
                    '定期清洗空調設備及隔塵網。',
                    '冷氣的恆溫器已調節至23°C，以減少浪費電能。',
                ],
                ENG: '',
            },
        },
        IT: {
            Intro: {
                CHI: [
                    '積極推動學生及老師使用資訊科技作教與學，創造一個具資訊科技文化的校園。',
                    '利用資訊科技，提高教與學的質素。',
                    '透過使用資訊科技，提升學校的行政效率。',
                    '利用電腦網絡通訊，促進學生、家長與學校之間的溝通。',
                ],
                ENG: '',
            },
            eLearningTitle: { CHI: '電子學習', ENG: 'e-Learning', },
            eCircularTitle: { CHI: '電子通告系統', ENG: 'e-Circular', },
            eCircularContent: {
                CHI: '<p>本校於2015年開始以電子方式發放通告，家長可透過學校流動應用程式MyTYH或利用eClass內聯網系統，檢查最新通告，綜合通告一般會於每個月的月底發放。</p><!--<p><a href="https://www.pohtyh.edu.hk/sadc/task2/eLearningGuide1.pdf" target="_blank">XXXXXX按此參閱電子通告的檢視方式及回覆方法</a></p>--><p><u>電子通告注意事項:</u></p><ol><li>回覆類別:<ul><li>有回條: 家長瀏覽此類通告後，須於系統上作出選擇(如參加/不參加、同意/不同意等)，然後按簽署。</li><li>沒有回條: 家長瀏覽此類通告後，無須於系統上作出任何選擇，只需按簽署便可。</li></ul></li><li>若家長有一名子女在本校就讀，則有一個帳戶，若有兩名，則有兩個帳戶，如此類推。</li><li>家長有責任維護自己的帳戶資料及使用權，不可安排由子女或其他人仕代為回覆通告。</li><li>校方可透過系統知道家長的瀏覽及回覆情況。如發現家長沒有檢閱及回覆，會透過發放訊息提醒家長。</li><li>如因電腦故障或其他原因而暫時未能接收通告，請於手冊上的「通訊欄」通知班主任，並著學生向班主任索取紙本通告。</li></ol>',
                ENG: '',
            },
            ePaymentTitle: { CHI: '電子繳費系統', ENG: 'e-Payment', },
            ePaymentContent: {
                CHI: '<p>本校透過「加強公營學校行政試驗計劃」，設立了eClass校園電子繳費系統，目的為簡化現時學生繳交學校各項費用時的交收流程和減少現金或支票交易時可能出現的錯誤，並減低學生攜帶與遺失現金的風險。</p><p>家長須要先為 貴子弟的電子繳費戶口作出增值，如日後本校須要作出收費，會於發出及收回通告後，於電子繳費系統作自動扣除， 貴家長及子弟可於系統中檢閱相關的交易紀錄。請注意， 貴家長應在繳費通告發出後確保電子繳費戶口有足夠的餘額，如果發現餘額不足，敬請自行為戶口增值。電子繳費戶口的餘額將於 貴子弟畢業離校時以支票發回。</p><ol><li><u>增值方法</u><p>家長可使用以下任何一種方法為繳費戶口增值:</p><ol type="A"><li>方法一: 繳費靈</li><li>方法二: OK便利店、華潤萬家分店或VanGo便利店之櫃位賬單繳費服務<ul><li>學生或家長可以選擇到OK便利店、華潤萬家分店 或VanGo便利店為電子繳費戶口增值。</li><li>請學生帶同學生證(背上應貼有繳費編碼)，或請家長帶備家長證(將於1月31家長日派發)，交予店員掃描繳費編號。</li><li>請學生或家長向店員表示要增值的金額，然後將金額交易店員。</li><li>增值後請自行保存收據，以便日後於需要時作出檢查。</li></ul></li></ol></li><li><u>增值行政費用</u><p>每次家長為繳費戶口增值時，因涉及繳費靈公司的商業運作，會因應增徝的途徑而作出不同的增值行政費，以下為各增值途徑的收費表，除每學年首兩次增值行政費由學校支付外，其餘的增值行政費會在 貴家長的電子繳費戶口中扣除。</p><table><tbody><tr><th>增值途徑</th><th>增值行政費</th></tr><tr><td>電話 / 網上繳費靈 PPS</td><td style="padding-left: 8px;">$2.2</td></tr><tr><td>現金OK便利店、華潤萬家分店 或 VanGo 便利店</td><td style="padding-left: 8px;"> $3.4</td></tr></tbody></table><p>由於每次增值均會涉及第三方公司的行政費用，因此建議家長每次增值的金額不宜過少，避免每次繳費均要為戶口作出增值。此外，為節省增值行政費，建議 貴家長採用電話 / 網上繳費靈PPS的增值方法。</p></li><li><u>檢查電子繳費戶口紀錄之方法</u><p>家長及學生均可透過校園電子繳費系統檢查戶口結餘、各項增值及繳費紀錄，各方法如下:</p><p>家長:</p><ul><li>透過學校流動應用程式MyTYH</li><li>利用「eClass」內聯網系統</li></ul><p>學生:</p><ul><li>利用現有的學生戶口，於「eClass」內聯網系統的「我的智能卡紀錄」檢查</li></ul><p>注意，由於增值涉及第三方公司的運作，有關的增值紀錄最少五個工作天後才可於系統中檢。如有問題，可致電本校查詢。</p></li></ol>',
                ENG: '',
            },
            ParentCardTitle: { CHI: '家長證', ENG: 'Parent Card', },
            ParentCardContent: {
                CHI: ['為配合電子繳費系統， 貴家長將獲發一張家長證，上面會列印電子繳費戶口的繳費條碼，用作櫃面繳費方式使用。此家長證可同時作為 貴家長於午膳送飯盒予 貴子弟時進行校園拍卡登記之使用，如 貴家長已申請一張家長證，該證將於新證派發後失效，請家長自行將舊証銷毀。請 貴家長妥善保存家長證，如因遺失，請盡快通知本校以作註銷，補領新證的費用為$20。'],
                ENG: '',
            },
            LTTitle: { CHI: '學與教', ENG: 'Learning and Teaching', },
            LTContent: {
                CHI: ['推動各科運用資訊科技教育作互動學習，管理及推動網上學習及溝通平台(eClass、閱讀平台)'],
                ENG: '',
            },
            AdminTitle: { CHI: '行政管理', ENG: 'Administration', },
            AdminContent: {
                CHI: ['管理、維護及發展學校各類資訊系統，促進學校的行政及知識管理電腦化。例如：WebSAMS，圖書館系統，SA系統，智能學生証等等…'],
                ENG: '',
            },
        },
        LanTingJu: {
            Intro: {
                CHI: ['為了給同學提供一個課餘時間休閒、放學留校自修的好去處，學校特興建「蘭亭聚」。'],
                ENG: ['為了給同學提供一個課餘時間休閒、放學留校自修的好去處，學校特興建「蘭亭聚」。'],
            },
            Section: {
                CHI: ['「蘭亭聚」一名，乃由本校前副校長高繼標老師所賜，取《蘭亭序》中「群賢畢至，少長咸集」之意，改「序」為「聚」。高老師不愧是才子，妙用前人典故，道出了本校興建此處的心意：'],
                ENG: ['「蘭亭聚」一名，乃由本校前副校長高繼標老師所賜，取《蘭亭序》中「群賢畢至，少長咸集」之意，改「序」為「聚」。高老師不愧是才子，妙用前人典故，道出了本校興建此處的心意：'],
            },
            Rest: {
                Title: { CHI: '(1)為同學暢聚提供文娛休憩區', ENG: '(1)為同學暢聚提供文娛休憩區' },
                Content: {
                    CHI: ['在課餘時間，同學既可與三五知己相約「蘭亭聚」， 一起看書、下棋、彈琴、談天、欣賞公園及貽園美景；也可相約參與「Let Me Shine」(讓我閃耀才藝表演)。一如古之賢才匯聚蘭亭，以文會友，遊目騁懷，暢敘幽情。',],
                    ENG: ['在課餘時間，同學既可與三五知己相約「蘭亭聚」， 一起看書、下棋、彈琴、談天、欣賞公園及貽園美景；也可相約參與「Let Me Shine」(讓我閃耀才藝表演)。一如古之賢才匯聚蘭亭，以文會友，遊目騁懷，暢敘幽情。',],
                },
            },
            SelfLearning: {
                Title: { CHI: '(2)為同學提供自修空間', ENG: '(2)為同學提供自修空間' },
                Content: {
                    CHI: ['昔日賢才，曲水流觴，以文會友。亦藉此祈盼英喜同學「博學、審問、慎思、明辨、篤行」，與同好砥礪共行。',],
                    ENG: ['昔日賢才，曲水流觴，以文會友。亦藉此祈盼英喜同學「博學、審問、慎思、明辨、篤行」，與同好砥礪共行。',],
                },
            },
            Other: {
                CHI: ['願英喜學子，在「蘭亭聚」，在生活中，「欣於所遇，快然自足」。',],
                ENG: ['願英喜學子，在「蘭亭聚」，在生活中，「欣於所遇，快然自足」。',],
            },
            Naming: {
                CHI: ['命名: 高繼標老師　　　　題字: 何琪同學',],
                ENG: ['命名: 高繼標老師　　　　題字: 何琪同學',],
            },
            Award: {
                Title: {
                    CHI: '「蘭亭聚」榮獲 Muse Design Award的金獎及London Design Award的銀獎',
                    ENG: '「蘭亭聚」榮獲 Muse Design Award的金獎及London Design Award的銀獎'
                },
                Content: {
                    CHI: ['Muse Design Awards及London Design Awards均是由國際獎項協會 (IAA)所設的獎項，是全球創意設計界最具影響力的獎項之一。獎項旨在表彰各領域中展現卓越創新、美學與影響力的傑出作品，範疇涵蓋建築、室內、產品及時尚等多個類別。評審過程由數百位國際專家組成評審團，採用嚴格的盲審制度，以確保公平性與公正性。該獎項被視為推動全球設計水平提升的重要指標。', '「蘭亭聚」獲獎，足見設計獲得國際級認可！'],
                    ENG: ['Muse Design Awards及London Design Awards均是由國際獎項協會 (IAA)所設的獎項，是全球創意設計界最具影響力的獎項之一。獎項旨在表彰各領域中展現卓越創新、美學與影響力的傑出作品，範疇涵蓋建築、室內、產品及時尚等多個類別。評審過程由數百位國際專家組成評審團，採用嚴格的盲審制度，以確保公平性與公正性。該獎項被視為推動全球設計水平提升的重要指標。', '「蘭亭聚」獲獎，足見設計獲得國際級認可！'],
                },
            },
        },
        MusicRoom: {
            Intro: {
                Title: { CHI: '音樂荳芽的培植場', ENG: '音樂荳芽的培植場' },
                Content: {
                    CHI: [
                        '配合音樂課的發展需要，本校特將音樂室改建成設備齊全舒適的樂樂音樂廳，讓學生有一個舒適的環境享受及學習音樂。另外，也完善了流行樂隊室及錄音室，以方便同學進行創作及進行樂隊練習活動。',
                        '在課堂內，本校鼓勵同學作多方面的嘗試，除了基本樂理、音樂歷史及合唱訓練外，也教授同學鍵盤彈奏技巧、使用iPad創作及進行小組音樂回報等，讓同學有多元化的機會發展所長。在每個學期的考試，同學們的多元化表演也令我們這個音樂廳充滿掌聲。',
                        '在放學後，管樂團、合唱團、無伴奏合唱團、音樂創作班、流行樂隊也為這裏帶來很多美妙的音樂聲和歡樂的笑聲。話雖如此，同學每個星期，一點一滴的付出也是很艱苦的。希望大家在這個園地，能把汗水和淚水化為成長的原料，讓這個校園和這個社區感受到同學們學習音樂的快樂。'
                    ],
                    ENG: [
                        '隨着音樂課的發展需要，本校音樂室於去年改建成設備齊全舒適的樂樂音樂廳，讓學生有一個舒適的環境享受及學習音樂。另外，也完善了流行樂隊室及錄音室，以方便同學進行創作及進行樂隊練習活動。',
                        '在課堂內，本校鼓勵同學作多方面的嘗試，除了基本樂理、音樂歷史及合唱訓練外，也教授同學鍵盤彈奏技巧、使用iPad創作及進行小組音樂回報等，讓同學有多元化的機會發展所長。在每個學期的考試，同學們的多元化表演也令我們這個音樂廳充滿掌聲。',
                        '在放學後，管樂團、合唱團、無伴奏合唱團、音樂創作班、流行樂隊也為這裏帶來很多美妙的音樂聲和歡樂的笑聲。話雖如此，同學每個星期，一點一滴的付出也是很艱苦的。希望大家在這個園地，能把汗水和淚水化為成長的原料，讓這個校園和這個社區感受到同學們學習音樂的快樂。'
                    ],
                },
            },
        },
        SolarPhotovoltaicSystems: {
            Intro: {
                'CHI': '本校透過<a href="https://re.emsd.gov.hk/tc_chi/gen/4S/4S.html" target="_blank">「採電學社」</a>計劃，在校舍的天台安裝了兩套發電容量各為10千瓦(kW)的太陽能發電系統，將轉化後的電能接入電網，並透過<a href="https://re.emsd.gov.hk/tc_chi/fit/int/fit_int.html" target="_blank">「上網電價」</a>計劃，將扣除保養後的電價收益，為學校的環保教育及綠色校園提供可持續的發展，同時亦讓學生及公眾明白可再生能源的實際應用及意義。',
                'ENG': ''
            },
            irradiance: { 'CHI': '太陽輻射量', 'ENG': 'Irradiance' },
            temperature: { 'CHI': '溫度', 'ENG': 'Temperature' },
            humidity: { 'CHI': '相對濕度', 'ENG': 'Humidity' },

            generation: { 'CHI': '產生的電量kWh(發電度數):', 'ENG': 'Generated Power kWh (Degrees of power generation):' },

            today: { 'CHI': '今日', 'ENG': 'Today' },
            thisMonth: { 'CHI': '本月', 'ENG': 'This Month' },
            grandTotal: { 'CHI': '由建設起累計', 'ENG': 'Grand Total' },
            phase1: { 'CHI': '第一期', 'ENG': 'Phase 1' },
            phase2: { 'CHI': '第二期', 'ENG': 'Phase 2' },
            phase3: { 'CHI': '第三期', 'ENG': 'Phase 3' },
            total: { 'CHI': '總計', 'ENG': 'Total' },

            Chart: { 'CHI': '統計圖:', 'ENG': 'Chart:' },
            choice: { 'CHI': '選擇以顯示額外的數據:', 'ENG': 'Choose the extra data type:' },

            SelfExplorationTitle: { 'CHI': '自主探索學習站:', 'ENG': 'Self-Exploration:' },
            SelfExplorationQuestion: [
                {
                    'CHI': '太陽能系統所產生的電量，與什麼因素相關呢?',
                    'ENG': 'What factors are related to the electricity generated by the solar system?'
                },
            ],

            chartToday: { 'CHI': '今日實時累計總發電量', 'ENG': 'Today Power Generation' },
            chartMonthly: { 'CHI': '本月各日總發電量', 'ENG': 'Daily Power Generation' },
            chartYearly: { 'CHI': '各月總發電量', 'ENG': 'Monthly Total Power Generation' },
            chartDailyYield: { 'CHI': '產生電量', 'ENG': 'Generated Power' },
            chartIrradiance: { 'CHI': '太陽輻射量', 'ENG': 'Irradiance' },
            chartTemperature: { 'CHI': '溫度', 'ENG': 'Temperature' },
            chartHumidity: { 'CHI': '濕度', 'ENG': 'Humidity' },

            noChartTextToday: { 'CHI': '每天大約早上8時半開始提供數據', 'ENG': 'Chart will be displayed after 8:30AM every day' },
        },
    },
    InfoDay: {
        Title: { CHI: '2025升中資訊日', ENG: '2025 Info Day' },
        Content: {
            CHI: '<p>本校將舉辦升中資訊日，我們誠邀各位家長參與是次活動。內容包括學校簡介、培育學生成長策略分享、自行收生計分方法簡介、體驗參觀。</p><p>日期：2025年12月6日(星期六)<br />時間：下午2時至下午4時30分<br />地點：本校<br />名額：由於報名人數眾多，每家庭參與人數上限為3人。<br />(如有特別原因，需要申請額外名額，請致電22463221查詢)<br />備註：參與名額有限，先到先得。</p>',
            ENG: '<p>本校將舉辦升中資訊日，我們誠邀各位家長參與是次活動。內容包括學校簡介、培育學生成長策略分享、自行收生計分方法簡介、體驗參觀。</p><p>日期：2025年12月6日(星期六)<br />時間：下午2時至下午4時30分<br />地點：本校<br />名額：由於報名人數眾多，每家庭參與人數上限為3人。<br />(如有特別原因，需要申請額外名額，請致電22463221查詢)<br />備註：參與名額有限，先到先得。</p>',
        },
        Magazine: { CHI: '校刊', ENG: 'School Magazine' },
        Form: {
            Error: {
                ParentName: { CHI: '請提供家長姓名', ENG: 'Please provide name of parent' },
                StudentName: { CHI: '請提供學生姓名', ENG: 'Please provide name of student' },
                NoOfAttendees: {
                    CHI: '報名人數只可以1至3人，如有特別原因，需要申請額外名額，請致電22463221查詢',
                    ENG: 'The number of applicants can only be 1 to 3 people. Please call 22463221 for enquiries if you need to apply for additional places for special reasons.'
                },
                Phone: { CHI: '請提供正確的聯絡電話', ENG: 'Please provide correct contact no.' },
                Email: { CHI: '聯絡電郵必須包含「@」', ENG: 'Contact email must contain "@"' },
                CorrectForm: { CHI: '請提供正確資料', ENG: 'Please provide correct information' },
            },
            Title: { CHI: '活動報名', ENG: 'Application' },
            ParentName: { CHI: '家長姓名', ENG: 'Name of Parent' },
            StudentName: { CHI: '學生姓名', ENG: 'Name of Student' },
            PrimarySchool: { CHI: '學生就讀小學', ENG: 'Primary School' },
            NoOfAttendees: { CHI: '出席人數', ENG: 'The No. of Attendees' },
            Phone: { CHI: '聯絡電話', ENG: 'Contact No.' },
            Email: { CHI: '聯絡電郵', ENG: 'Email Address' },
            EmailNotice: { CHI: '用以發出確認通知', ENG: 'To issue confirmation notifications' },
            Message: { CHI: '擬向本校查詢的問題', ENG: 'Enquiry' },
            Register: { CHI: '登記', ENG: 'Register' },
            Statement: {
                CHI: '所有登記所得的資料，只會用作本次活動的用途，並於活動完結後一個月內銷毀。',
                ENG: 'All registered information will only be used for the purpose of this event and will be destroyed within one month after the event.',
            },
        },
        Snackbar: {
            Success: {
                CHI: '登記成功，確認電郵將於大約11月尾發放，請耐心等侯。',
                ENG: 'Thank you for your registration. The confirmation email will be sent around the end of November, please wait patiently.'
            },
            Failure: {
                CHI: '登記失敗，請確認你的資料是否經已填妥，如有問題請直接致電聯絡本校校務處(22463221)查詢。',
                ENG: 'Registration failed. Please make sure your information has been filled correctly. Please call our school office (22463221) if you have any questions.'
            },
        },
    },
    LearningAndTeacher: {
        AppliedLearning: {
            IntroTitle: { CHI: '課程簡介', ENG: 'Course Introduction' },
            IntroContent: {
                CHI: ['應用學習(Applied Learning, ApL)是高中課程的選修科目之一，是中學文憑考試的乙類科目。課程內容實踐與理論並重，緊密連繫專業和職業領域，配合核心科目、選修科目及其他學習經歷，讓學生體驗全面的學習經歷。'],
                ENG: ['應用學習(Applied Learning, ApL)是高中課程的選修科目之一，是中學文憑考試的乙類科目。課程內容實踐與理論並重，緊密連繫專業和職業領域，配合核心科目、選修科目及其他學習經歷，讓學生體驗全面的學習經歷。'],
            },
            GainedTitle: { CHI: '學生得着', ENG: 'Student Gained from the course' },
            GainedContent: {
                CHI: ['學生可以從多元化的課程中尋找適合自己的科目，學習相關的基礎理論和概念，發展與職業相關的能力及共通能力，探索事業抱負和終身學習方向。'],
                ENG: ['學生可以從多元化的課程中尋找適合自己的科目，學習相關的基礎理論和概念，發展與職業相關的能力及共通能力，探索事業抱負和終身學習方向。'],
            },
            KnowMore: { CHI: '了解更多', ENG: 'Know More' },
        },
        Curriculum: {
            Subject: { CHI: '科目', ENG: 'Subjects' },
        },
        ElectiveSubjectIntro: {
            APL: { CHI: '應用學習', ENG: 'Applied Learning' },
            BAFS: { CHI: '企業、會計與財務概論', ENG: 'Business, Accounting and Financial Studies' },
            BIO: { CHI: '生物', ENG: 'Biology' },
            CHEM: { CHI: '化學', ENG: 'Chemistry' },
            CHIST: { CHI: '中國歷史', ENG: 'Chinese History' },
            ECON: { CHI: '經濟', ENG: 'Economics' },
            GEO: { CHI: '地理', ENG: 'Geography' },
            ICT: { CHI: '資訊及通訊科技', ENG: 'Information and Communications Technology' },
            M2: { CHI: '數學延伸部分單元二', ENG: 'Mathematics Extended Part Module 2' },
            PE: { CHI: '體育', ENG: 'Physical Education' },
            PHY: { CHI: '物理', ENG: 'Physics' },
            TH: { CHI: '旅遊與款待', ENG: 'Tourism and Hospitality Studies' },
            VA: { CHI: '視覺藝術', ENG: 'Visual Arts' },
        },
        EnglishEducation: {
            Title: 'English Learning Environment',
            Content: ['English language is taught as a discrete subject at TYH by a mixture of native and non-native speakers. Emphasis is placed on the need to develop an all-round English language capability and students are given a rich diet of learning opportunities both inside and outside classrooms to encourage more interactive learning, thus helping students become independent lifelong learners, creative thinkers and problem solvers who can communicate effectively in English.'],
            KnowMore: 'Know More',
        },
        GiftedEducation: {
            Slogan: { CHI: '資優教育　潛能所屬', ENG: '資優教育　潛能所屬' },
            Content: {
                CHI: '本校致力發掘及培育學生各方面的才能，故此成立資優教育組，為學術表現卓越的學生，提供校本資優教育課程。資優教育組重點發展資優學生學科高層次思維，培養資優學生自主學習，關顧資優學生行為及情意需要。在學術進階培訓方面，課程包括寫作思維訓練、中華文化桌遊訓練、英語會話及辯論訓練以及數理邏輯訓練等。此外，資優教育組亦為資優學生提供全方位學習活動，如訪問各界成功人士、參觀企業、參加聯校交流等，以擴闊視野，見賢思齊，追求卓越。資優教育組亦為資優學生提供個人化生涯規劃及情意教育，以幫助學生達致全人發展。',
                ENG: '本校致力發掘及培育學生各方面的才能，故此成立資優教育組，為學術表現卓越的學生，提供校本資優教育課程。資優教育組重點發展資優學生學科高層次思維，培養資優學生自主學習，關顧資優學生行為及情意需要。在學術進階培訓方面，課程包括寫作思維訓練、中華文化桌遊訓練、英語會話及辯論訓練以及數理邏輯訓練等。此外，資優教育組亦為資優學生提供全方位學習活動，如訪問各界成功人士、參觀企業、參加聯校交流等，以擴闊視野，見賢思齊，追求卓越。資優教育組亦為資優學生提供個人化生涯規劃及情意教育，以幫助學生達致全人發展。'
            },
        },
        LearningSupportProgramme: {
            Caring: {
                Title: { CHI: '全校參與照顧學生的多樣性', ENG: 'Whole-school Engagement in Caring for Student Diversity' },
                Content: {
                    CHI: [
                        '各級均推行各項課後學習支援計畫（拔尖保底）。',
                        '初中及高中：中文科、英文科均設分組教學（4班5組）。',
                        '開設多元化選修科以及增設應用學習科，以供學生選讀。',
                    ],
                    ENG: [
                        '各級均推行各項課後學習支援計畫（拔尖保底）。',
                        '初中及高中：中文科、英文科均設分組教學（4班5組）。',
                        '開設多元化選修科以及增設應用學習科，以供學生選讀。',
                    ],
                }
            },
            Measures: {
                Title: { CHI: '測考及學習調適措施', ENG: 'Testing and Learning Adaptation Measures' },
                Content: {
                    CHI: ['全年兩次考試，兩次統測。採取「小步多測」及多元化持續評估策略（如測驗、功課、閱讀報告及專題報告表現等），全面評估學生的知識、學習技能及學習態度。'],
                    ENG: ['全年兩次考試，兩次統測。採取「小步多測」及多元化持續評估策略（如測驗、功課、閱讀報告及專題報告表現等），全面評估學生的知識、學習技能及學習態度。'],
                }
            },
            IntegratedEducation: {
                Title: { CHI: '全校參與模式融合教育', ENG: '全校參與模式融合教育' },
                Content: {
                    CHI: ['本校以「全校參與」模式支援有特殊教育需要的學生。透過運用學校發展津貼、學習支援津貼、增補基金和社區資源，為學生提供適切和多元化的支援服務，以提升學生的學習效能及協助他們融入校園生活。'],
                    ENG: ['本校以「全校參與」模式支援有特殊教育需要的學生。透過運用學校發展津貼、學習支援津貼、增補基金和社區資源，為學生提供適切和多元化的支援服務，以提升學生的學習效能及協助他們融入校園生活。'],
                }
            },
        },
        PromotionReading: {
            Intro: {
                Title: { CHI: '簡介', ENG: 'Introduction' },
                Content: {
                    CHI: ['閱讀推廣及圖書館服務組除計畫和管理學校圖書館的日常運作外，亦負責統籌及管理閱讀相關的資源，以支援學生閱讀及從閱讀中學習。'],
                    ENG: ['閱讀推廣及圖書館服務組除計畫和管理學校圖書館的日常運作外，亦負責統籌及管理閱讀相關的資源，以支援學生閱讀及從閱讀中學習。'],
                },
            },
            Promotion: {
                Title: { CHI: '推廣閱讀', ENG: 'Reading Promotion' },
                Content: {
                    CHI: ['我們透過跨科組的閱讀活動，增加學生閱讀的樂趣，並認識不同範疇的知識。'],
                    ENG: ['我們透過跨科組的閱讀活動，增加學生閱讀的樂趣，並認識不同範疇的知識。'],
                },
            },
            Coordinate: {
                Title: { CHI: '統籌及管理閱讀資源', ENG: 'Coordinate and Manage Reading Resources' },
                Content: {
                    CHI: ['我們與學科教師協作，因應學生的需要、課程內容要求，為學生學習提供所需的學習資源。'],
                    ENG: ['我們與學科教師協作，因應學生的需要、課程內容要求，為學生學習提供所需的學習資源。'],
                },
            },
            Librarian: {
                Title: { CHI: '培訓尖子(圖書館領袖生)', ENG: 'Training Top Students(Librarian)' },
                Content: {
                    CHI: ['圖書館領袖生透過服務同學、帶領活動以及領導組員，藉以啟發學生的潛能、培養恆毅力以及同理心。'],
                    ENG: ['圖書館領袖生透過服務同學、帶領活動以及領導組員，藉以啟發學生的潛能、培養恆毅力以及同理心。'],
                },
                Members: {
                    Title: { CHI: '我們的圖書館領袖生', ENG: 'Our Librarians' },
                    Chief: {
                        Title: { CHI: '首席', ENG: 'Chief' },
                        Members: ['5A 張鐫騫', '5A 成丹妮'],
                    },
                    DeputyChief: {
                        Title: { CHI: '副首席', ENG: 'Deputy Chief' },
                        Members: ['5A 列俊希', '5A 周朗迪', '4B 周凱晴', '5C 謝德謙', '5A 秦樂瑤'],
                    },
                    /*Ambassador: {
                        Title: { CHI: '閱讀推廣大使', ENG: 'Reading Promotion Ambassador' },
                        Members: ['4A 張鐫騫', '5B 林東炫'],
                    },*/
                    Librarians: {
                        Title: { CHI: '圖書館領袖生', ENG: 'Librarians' },
                        Leaders: {
                            Title: {
                                1: { CHI: '星期一組長', ENG: 'Leader of Mon' },
                                2: { CHI: '星期二組長', ENG: 'Leader of Tue' },
                                3: { CHI: '星期三組長', ENG: 'Leader of Wed' },
                                4: { CHI: '星期四組長', ENG: 'Leader of Thu' },
                                5: { CHI: '星期五組長', ENG: 'Leader of Fri' }
                            },
                            Members: {
                                1: ['5A 林政熙', '4A 歐陽智恆'],
                                2: ['4B 譚衍樂', '4C 王進熙'],
                                3: ['3A 孫愿慈', '3A 何奕晞'],
                                4: ['4C 黃嘉朗', '5C 楊穎翹'],
                                5: ['3C 蔡永軒']
                            }
                        },
                        Members: {
                            Title: { CHI: '組員', ENG: 'Member' },
                            Members: {
                                1: [
                                    "1A 吳希姸",
                                    "1B 張嘉澄",
                                    "1B 林熙悠",
                                    "2A 余政熹",
                                    "4B 周鴻鍇",
                                    "4C 張曉鏗",
                                    "5A 柯寶軒",
                                    "5A 黎丹妍",
                                    "5A 林靖熙",
                                    "5C 陸梓峰",
                                    "4A 莊詠珊",
                                    "4A 林靄千",
                                ],
                                2: [
                                    "1B 賀逸逸",
                                    "1B 黄嘉雯",
                                    "1C 徐舒婷",
                                    "1C 阮穎翹",
                                    "2A 楊采翹",
                                    "2B 黃皓楠",
                                    "2B 楊家蕙",
                                    "2C 黃光耀",
                                    "4A 楊政淳",
                                    "4D 陳家揚",
                                    "5A 黃卓謙",
                                    "5A 莊崇晞",
                                ],
                                3: [
                                    "1B 黃嘉棋",
                                    "1D 陳梓瑜",
                                    "1D 黃楒媤",
                                    "1D 謝煒婷",
                                    "2C 黃愷恩",
                                    "2C 楊芷熙",
                                    "3B 黃焯榆",
                                    "3B 陸詩婷",
                                    "3D 許隼熙",
                                    "4B 劉詩泳",
                                    "4C 沈柔",
                                ],
                                4: [
                                    "1B 鄭芷雅",
                                    "2A 許雯晴",
                                    "2C 楊梓瑜",
                                    "2C 張永亮",
                                    "3D 羅卓怡",
                                    "4C 方曉晴",
                                    "4C 戴思朗",
                                    "4D 黎子熙",
                                    "5A 鄔樂琳",
                                ],
                                5: [
                                    "1C 黎詩琳",
                                    "2A 吳鎧堯",
                                    "2A 張頌揚",
                                    "2C 曾嘉怡",
                                    "3B 郭勛奇",
                                    "5A 楊嘉瑤",
                                    "5B 李家佑",
                                ],
                            },
                        },
                    }
                }
            },
            EBook: {
                Title: { CHI: '網上閱讀平台', ENG: 'e-Reading' },
            },
            ELearning: {
                Title: { CHI: '網上學習資源', ENG: 'e-Learning' },
                Links: {
                    Title: { CHI: '網站連結', ENG: 'Useful Links' },
                    Items: [
                        {
                            Subject: { CHI: '中文科', ENG: 'Chinese Language' },
                            Links: [
                                {
                                    url: 'http://humanum.arts.cuhk.edu.hk/Lexis/Canton/',
                                    text: '黃錫凌《粵音韻彙》'
                                },
                                {
                                    url: 'http://www.edb.gov.hk/tc/curriculum-development/kla/chi-edu/index.html',
                                    text: '教育局課程發展處中國語文教育網頁'
                                },
                                {
                                    url: 'http://www.kwuntung.net/check/',
                                    text: '免寫錯字之選：東東錯別字詞典'
                                },
                                {
                                    url: 'http://www.rthk.org.hk/chiculture/1minchinese/',
                                    text: '中文一分鐘'
                                },
                                {
                                    url: 'http://zhongwen.com/gudian.htm',
                                    text: '中國古典文學'
                                },
                                {
                                    url: 'http://dict.revised.moe.edu.tw/cbdic/',
                                    text: '教育部重編國語辭典修訂本'
                                },
                                {
                                    url: 'http://www.amtb.org.tw/pdf/ch31-04-1.pdf',
                                    text: '文本古文觀止(PDF版)'
                                },
                                {
                                    url: 'http://www.gushiwen.org/wenyan/',
                                    text: '古詩文網'
                                },
                                {
                                    url: 'https://chinese.i-learner.com.hk/',
                                    text: '智愛中文平台'
                                },
                            ],
                        },
                        {
                            Subject: { CHI: '英文科', ENG: 'English Language' },
                            Links: [
                                {
                                    url: 'http://dictionary.cambridge.org/',
                                    text: 'Cambridge Dictionary Online'
                                },
                                {
                                    url: 'http://www.bbc.co.uk/radio',
                                    text: 'BBC.com'
                                },
                                {
                                    url: 'http://yp.scmp.com/',
                                    text: '青年報Young Post(SCMP)'
                                },
                                {
                                    url: 'http://www.starfall.com/',
                                    text: 'Learn to Read'
                                },
                                {
                                    url: 'http://www.britishcouncil.hk/',
                                    text: '英國文化協會'
                                }
                            ],
                        },
                        {
                            Subject: { CHI: '數學科', ENG: 'Mathematics' },
                            Links: [
                                {
                                    url: 'http://www.edb.gov.hk/tc/curriculum-development/kla/ma/res/glossary-notes.html',
                                    text: '數學科常用英漢辭彙'
                                },
                                {
                                    url: 'http://episte.math.ntu.edu.tw/',
                                    text: '數字知識'
                                },
                                {
                                    url: 'http://math.com/',
                                    text: 'Math.com'
                                }
                            ],
                        },
                        {
                            Subject: { CHI: '公民與社會發展科', ENG: 'Citizenship and Social Development' },
                            Links: [
                                {
                                    url: 'https://www.stheadline.com/education/%E6%95%99%E8%82%B2',
                                    text: '星島教育網'
                                },
                                {
                                    url: 'https://life.mingpao.com/main',
                                    text: '明報教育網'
                                },
                                {
                                    url: 'http://ls.hket.com/ls/',
                                    text: '經濟日報教育網'
                                },
                                {
                                    url: 'https://edu.hkej.com/php/index.php',
                                    text: '信報教育網'
                                },
                                {
                                    url: 'https://cs.edb.edcity.hk/tc/index_cs.php',
                                    text: '公民與社會發展科 網上資源平台'
                                },
                            ],
                        },
                        {
                            Subject: { CHI: '生涯規劃', ENG: 'Life Planning' },
                            Links: [
                                {
                                    url: 'https://www.hyc.org.hk/',
                                    text: '學友社'
                                },
                                {
                                    url: 'https://lifeplanning.edb.gov.hk/tc/',
                                    text: '教育局--生涯規劃'
                                }
                            ],
                        },
                        {
                            Subject: { CHI: '音樂科', ENG: 'Music' },
                            Links: [
                                {
                                    url: 'http://polygonguitar.blogspot.hk/2015/07/chord_22.html',
                                    text: 'POLYGON 結他CHORD'
                                },
                                {
                                    url: 'http://www.guitarians.com/',
                                    text: 'Guitarians.com 結他譜'
                                },
                                {
                                    url: 'https://www.poppiano.org/',
                                    text: '鋼琴譜'
                                }
                            ],
                        },
                        {
                            Subject: { CHI: '家政科', ENG: 'Home Economics' },
                            Links: [
                                {
                                    url: 'http://www.christinesrecipes.com/',
                                    text: '簡易食譜'
                                },
                                {
                                    url: 'https://icook.tw/',
                                    text: '愛料理'
                                },
                                {
                                    url: 'http://hk-kitchen.lkk.com/zh-HK/Kitchen/Recipe/QuickFix',
                                    text: '李錦記簡易食譜'
                                },
                                {
                                    url: 'http://www.knorr.hk/',
                                    text: '家樂牌網上食譜'
                                },
                                {
                                    url: 'https://www.towngascooking.com/tc/Recipe/',
                                    text: '煤氣烹飪中心 網上食譜'
                                },
                                {
                                    url: 'http://restaurant.eatsmart.gov.hk/b5/content.asp?content_id=288',
                                    text: '有『營』食譜'
                                }
                            ],
                        },
                        {
                            Subject: { CHI: '悅讀學會', ENG: '悅讀學會' },
                            Links: [
                                { url: 'https://www.youtube.com/watch?v=b-9lvl_-z2s', text: '說故事技巧' },
                                {
                                    url: 'https://www.youtube.com/watch?v=3-rTAFt_RNc',
                                    text: '選書+說故事的小貼士：菜姨姨有心水之選'
                                },
                                {
                                    url: 'https://www.youtube.com/watch?v=Ep0NgCGjUxk',
                                    text: '不說道理 只說故事：菜姨姨有心水之選'
                                },
                                {
                                    url: 'https://www.youtube.com/watch?v=Xd23gDo3Lhg',
                                    text: '讀書時節 好書分享'
                                },
                                {
                                    url: 'https://chiculture.org.hk/tc/node/5',
                                    text: '燦爛的中國文明'
                                },
                                {
                                    url: 'https://chin.eduhk.mers.hk/animation.php',
                                    text: '與文同樂小魚字游樂'
                                },
                                {
                                    url: 'https://kids.nationalgeographic.com/',
                                    text: '英文國家地理雜誌兒童版'
                                },
                                {
                                    url: 'https://www.hkpl.gov.hk/tc/e-resources/e-databases/home/all/1',
                                    text: '公共圖書館電子資源'
                                },
                                {
                                    url: 'https://www.hkreadingcity.net/channel/celebrity',
                                    text: '香港閱讀城(名人好書推介)'
                                },
                            ],
                        },
                    ],
                },
            },
            Recommended: {
                Title: { CHI: '推介圖書', ENG: 'Recommended Books' },
                Teacher: { CHI: '推介老師', ENG: 'Teacher' },
            },
            Video: {
                Title: { CHI: 'BOOK一分鐘', ENG: 'BOOK 1 Minute' },
                Bookname: { CHI: '書名', ENG: 'Book Name' },
                Staff: { CHI: '好書推介', ENG: 'Recommended by' },
                VO: { CHI: '聲音導航', ENG: 'Voice Navigation' },
                Production: { CHI: '短片製作', ENG: 'Video Production' },
            },
            GoodBooks: {
                Title: { CHI: '好書龍虎榜', ENG: 'Good Books' },
            },
            NewBooks: {
                Title: { CHI: '新書推介', ENG: 'New Books' },
            },
            Ranking: {
                Title: { CHI: '班際閱讀龍虎榜', ENG: 'Class Reading Ranking' },
            },
            Navigate: {
                Intro: { CHI: '簡介', ENG: 'Introduction' },
                Librarians: { CHI: '圖書館領袖生', ENG: 'Librarians' },
                ELearning: { CHI: '電子學習', ENG: 'e-Learning' },
                Recommended: { CHI: '推介圖書', ENG: 'Book Recommendation' },
                Ranking: { CHI: '閱讀龍虎榜', ENG: 'Reading Ranking' },
            }
        },
        SubjectsDSE: {
            CoreCurriculumTitle: { CHI: '核心課程', ENG: 'Core Curriculum' },
            CompulsorySubjectsTitle: { CHI: '必修科目', ENG: 'Compulsory Subjects' },
            CoreCurriculumContent: {
                CHI: '中文、英文、數學、公民與社會發展',
                ENG: 'Chinese Language, English Language, Mathematics, Citizenship and Social Development'
            },
            NonCoreCurriculumTitle: { CHI: '非核心課程', ENG: 'Non-core Curriculum' },
            ElectiveSubject1Title: { CHI: '選修科1', ENG: 'Elective Subject 1' },
            ElectiveSubject1Content: {
                CHI: '經濟 / 中史 / 體育(文憑) / 視覺藝術(文憑) / 物理 / 生物',
                ENG: 'Econimic / Chinese History / Physical Education / Visual Arts / Physics / Biology'
            },
            ElectiveSubject2Title: { CHI: '選修科2', ENG: 'Elective Subject 2' },
            ElectiveSubject2Content: {
                CHI: '地理 / 旅遊及款待 / 企業、會計與財務概論 / 資訊及通訊科技 / 化學',
                ENG: 'Chemistry / Business, Accounting and Financial Studies / Tourism and Hospitality Studies / Geography / Information and Communications Technology'
            },
            ElectiveSubject3Title: { CHI: '選修科3', ENG: 'Elective Subject 3' },
            ElectiveSubject3Content: {
                CHI: '數延(單元2) / 生物 / 應用學習(2X學生) / 核心增潤課',
                ENG: 'Biology / Applied Learning / Core Enrichment Course / Mathematics Extended Part Module 2'
            },
            OtherCoursesTitle: { CHI: '其他課程', ENG: 'Other Courses' },
            MusicArt: { CHI: '視覺藝術 / 音樂', ENG: 'Visual Arts / Music' },
            PE: { CHI: '體育', ENG: 'Physical Education' },
            OLE: { CHI: '其他學習經歷', ENG: 'Other Learning Experiences' },
        },
        STEAMEducation: {
            Purpose: {
                Title: { CHI: 'STEAM教育的宗旨', ENG: 'Purpose of STEAM Education' },
                Content: {
                    CHI: ['實現學生「獲取和建構廣闊而穩固的知識基礎」，「綜合發展和應用共通能力」和「靈活、有效和合乎道德地運用資訊和資訊科技」。'],
                    ENG: ['實現學生「獲取和建構廣闊而穩固的知識基礎」，「綜合發展和應用共通能力」和「靈活、有效和合乎道德地運用資訊和資訊科技」。'],
                },
            },
            Vision: {
                Title: { CHI: 'STEAM教育的願景', ENG: 'Vision' },
                Content: {
                    CHI: ['本組透過不同正規課堂及課外活動，發展 STEAM 教育，讓學生充分發揮科學、數理、邏輯及創意潛能。如：初中學習物聯網及人工智能、愉快星期五創意科學學會活動等，以裝備學生應對新時代的轉變和挑戰。'],
                    ENG: ['本組透過不同正規課堂及課外活動，發展 STEAM 教育，讓學生充分發揮科學、數理、邏輯及創意潛能。如：初中學習物聯網及人工智能、愉快星期五創意科學學會活動等，以裝備學生應對新時代的轉變和挑戰。'],
                },
            },
            Highlights: {
                Title: { CHI: 'STEAM活動花絮', ENG: 'Event Highlights' },
            },
        },
        S1StudyTips: {
            Description: {
                CHI: '由小六升讀中一，是同學學習歷程中的重要階段。為了讓家長及同學更了解如何掌握中學各科的學習要點，本校特別編製了中一級「溫習錦囊」。錦囊集結了各評分科目的學習秘訣與備試建議，協助同學配合溫習範圍，制定良好的複習計劃，提升學習效能。',
                ENG: 'Transitioning from Primary Six to Secondary One is an important stage in students\' learning journey. To help parents and students better understand how to master the key points of learning in various subjects in secondary school, our school has specially compiled the S1 "Study Tips". The tips collection gathers the learning secrets and exam preparation suggestions of each assessed subject, assisting students in following the revision scope, formulating a good review plan, and improving learning efficiency.'
            },
            Subject: {
                CHI: { CHI: '中國語文', ENG: 'Chinese Language' },
                ENG: { CHI: '英國語文', ENG: 'English Language' },
                MATH: { CHI: '數學', ENG: 'Mathematics' },
                CES: { CHI: '公經社', ENG: 'Learning and Teaching Resources: Citizenship, Economics and Society ' },
                PTH: { CHI: '普通話', ENG: 'Putonghua' },
                CHIST: { CHI: '中國歷史', ENG: 'Chinese History' },
                HIST: { CHI: '歷史', ENG: 'History' },
                GEO: { CHI: '地理', ENG: 'Geography' },
                ICT: { CHI: '資訊與通訊科技', ENG: 'Information and Communications Technology' },
                IS: { CHI: '綜合科學', ENG: 'Integrated Science' },
            }
        }
    },
    MusicalWork: {
        Title: { CHI: '英喜音樂創作匯萃', ENG: 'Music Creation' },
        Activities: { CHI: '活動花絮', ENG: 'Event Highlights' },
        CreativeCollection: { CHI: '鄧英喜中學創作集', ENG: 'T.Y.H. Creative Collection' },
        Creation: { CHI: '師生創作', ENG: 'Teacher and Student Creation' },
        Interdisciplinary: { CHI: '跨學科作品', ENG: 'Interdisciplinary Works' },
        Performance: { CHI: '公開表演', ENG: 'Public Performance' },
        Youtube: { CHI: '觀賞更多影片 ', ENG: 'Watch our channel' },
        Graduation: { CHI: '鄧英喜畢業歌', ENG: 'T.Y.H. Graduation Song' },
        Musical: {
            CHI: '本校原創音樂劇《樂樂樂情天》歌曲精選',
            ENG: 'Selected songs from our musical "樂樂樂情天"'
        },
        Story: { CHI: '故事內容', ENG: 'Stort' },
    },
    MusicContest: {
        Title: { CHI: '音樂比賽2025-2026', ENG: 'Music Contest 2025-2026' },
        //Title: { CHI: '中六級歲月如歌歌唱比賽', ENG: '中六級歲月如歌歌唱比賽' },
        ListText: {
            CHI: [
                '比賽分創作組、樂器組、合唱組及獨唱組，參賽者必先參加初賽，進行選拔。',
                '參賽者必須找同學(或自己)伴奏，或自備無人聲之伴奏錄音mp3/youtube link。(樂器組除外)',
                '初賽日期為25/2(三)(合唱組)，2/3(一)(獨唱組)及9/3(樂器組)。創作組在2/3前交歌。',
                '注意:同學初賽可同時參加以上四組，但進入決賽只可為合唱組或獨唱組，樂器組及創作組則沒有限制。',
                '參加者均能為社取得1分。參與同學必須出席比賽，否則作棄權論，扣社分2分。',
                '獎項:',
                ['合唱組: 冠/亞/季'],
                ['獨唱組: 冠/亞/季'],
                ['樂器組: 冠/亞/季'],
                ['樂器組: 冠/亞/季'],
                '報名日期為15/1 - 23/1晚上11:59。報名請填妥學校網頁上的報名表，並於24/1前把歌UPLOAD。',
                /*'日期: 25/11/2024(二)',
                '時間: 4:00pm - 5:00pm',
                '地點: 本校禮堂',
                '比賽項目:',
                [
                    '獨唱組',
                    '合唱組(人數不限，但同一位同學只可參與1組)',
                ],
                '獎項:',
                [
                    '合唱組冠/亞/季軍',
                    '獨唱組冠/亞/季軍',
                    '評判特別獎',
                ],
                '參賽資料:',
                [
                    '所有中六同學均可參加',
                    '每人出場次數最多2次(合唱及獨唱)',
                    '報名連結請參考MyTYH App通告及同學的iMail',
                    '比賽限時於4分鐘內完成，連同自我介紹及感言',
                ],
                '評判: 朱慧敏老師 / 鄭詠恩老師',
                '截止報名: 12/11/2025 晚上12:00',*/
            ],
            ENG: [],
        },
        Form: { CHI: '請填妥以下資料', ENG: 'Please fill the form below' },
        GroupList: {
            Title: { CHI: '組別', ENG: 'Group' },
            Options: {
                CHI: ['獨唱組', '合唱組', '樂器組', '創作組',],
                ENG: ['獨唱組', '合唱組', '樂器組', '創作組',],
            }
        },
        NoOfParticipants: { CHI: '參賽人數', ENG: 'No. of participants' },
        ParticipantsDetail: { CHI: '參賽者資料', ENG: 'Detail of Participants' },
        Song: { CHI: '歌曲名稱 ', ENG: 'Song Name' },
        Instruments: { CHI: '自攜樂器', ENG: 'Instruments' },
        Modus: {
            Title: { CHI: '形式', ENG: 'Modus' },
            Options: {
                CHI: ['自彈自唱', '伴奏MMO',],
                ENG: ['自彈自唱', '伴奏MMO',],
            }
        },
        URL: { CHI: '伴奏歌曲網址', ENG: 'Accompaniment Song URL' },
        StudentID: { CHI: '申請者學生編號', ENG: 'Student ID of Applicant' },
        Password: { CHI: '密碼', ENG: 'Password' },
        ErrorNotice: { CHI: '請先填妥表單資料', ENG: 'Please fill in the form information before submission' },
        SuccessNotice: { CHI: '資料已被送出', ENG: '資料已被送出' },
    },
    News: {
        Title: { CHI: '最新消息', ENG: 'News' },
    },
    PTA: {
        Title: { CHI: '家長教師會', ENG: 'Parent-Teacher Association' },
        Intro: {
            CHI: ['本校家長教師會於2002年成立，旨在成為學校與家長之間的橋樑，加強家校溝通，體現家校團結合作精神。家長教師會定期舉行會議、親職教育活動、講座、聯誼活動等，以促進家長與學校之間的聯繫及協作，同時透過不同活動互相交流，讓孩子在家校關愛中健康成長，達至全人發展。'],
            ENG: ['本校家長教師會於2002年成立，旨在成為學校與家長之間的橋樑，加強家校溝通，體現家校團結合作精神。家長教師會定期舉行會議、親職教育活動、講座、聯誼活動等，以促進家長與學校之間的聯繫及協作，同時透過不同活動互相交流，讓孩子在家校關愛中健康成長，達至全人發展。'],
        },
        /*CommitteeTitle: {
            CHI: '2024-2025年度第二十三屆家長教師會常務委員會',
            ENG: '2024-2025 Standing Committee of the 23rd Parent-Teacher Association'
        },*/
        ChairmanSpeechTitle: {
            CHI: '主席感言',
            ENG: 'Chairman\'s Speech'
        },
        ChairmanSpeechContent: '<p align="right">吳玉蘭女士</p><p>季節更迭，給予每一個生命美麗的機會，轉眼間，我們又即將迎接新一個學期。</p><p>記得首次接觸家教會，是因為報名參加一個學校舉行的新年親子插花活動，過程中讓我感受到校長、老師、家長和同學們熱情、和諧、溫馨的一面。在一片歡笑聲中，我也很快投入了活動，不再拘謹，第二年我便隨即報名加入家教會常委會。我很感謝學校這些年來經常舉行親子活動，令家長能夠在孩子成長反叛期內，得到更多陪伴成長以及增強親子關係的機會。</p><p>李慧校長一直強調「教育不是工廠，每一位學生都是獨特的」，這一教育理念深深地打動了我。鄧英喜中學的老師會因應學生的特性和興趣引導他們學習，讓他們發揮潛能。我兒子由小學升中時，是一位比較軟弱、欠缺自信的男孩，走路總是低著頭，但今日的他，竟成為了學校四社社長的一員，發掘到他的領導能力，還找到他的興趣——音樂。這五年間，我見證了他在鄧英喜中學的成長和蛻變，我深感欣慰，也感恩我當時選擇了鄧英喜中學。</p><p>我知道這所學校的成功，不能單靠一個人的力量，而是學校裡每一位教職員，包括：校長、老師、工友等的努力及耐心灌溉。他們為學校，為學生建造的每一個角落都花盡心思，英語角、圖書室、音樂廳、咖啡廳、視藝室、茶藝室，還有建設中的健身室，這一切一切都讓學生有機會發揮所長，找到自信。學校不再是枯燥乏味的地方，而是一個明白他們需求而又能讓他們愉快學習的成長之地。</p><p>過去一年，最令我感動的是在參加學校不同活動時，有機會接觸到來自不同班級的家長。每當我聽到他們說：「幸好當時選擇了鄧英喜中學」，我也會感同身受，會心微笑，回應道：「我也是！」身為家教會常委會成員之一，我深感自豪。</p><p>讓我們家校攜手邁進，充滿期待與欣喜的新學期，亦祝願鄧英喜中學「綠樹擎天拂晴空，遍地春暉花似錦」，每一片葉子都努力生長，也熠熠生輝！</p>',
        Footer: {
            CHI: '歡迎各家長與本校家長教師會聯絡，本會會將您的意見向學校反映。',
            ENG: 'Parents are welcome to contact the Parent-Teacher Association, and the Association will reflect your opinions to the school.'
        },
        ContactPhone: {
            CHI: '電話: 2246 3221(與校務處郭小姐聯絡)',
            ENG: 'Phone No.: 2246 3221(Contact Ms. Choi of the School Affairs Office)'
        },
        ContactEmail: {
            CHI: '電郵: pta@pohtyh.edu.hk',
            ENG: 'Email: pta@pohtyh.edu.hk',
        },
        Role: {
            Chairman: { CHI: '主席', ENG: 'Chairman' },
            ViceChairman: { CHI: '副主席', ENG: 'Vice Chairman' },
            Secretary: { CHI: '秘書', ENG: 'Secretary' },
            Treasurer: { CHI: '司庫', ENG: 'Treasurer' },
            Contact: { CHI: '聯絡', ENG: 'Contact' },
            Recreation: { CHI: '康樂', ENG: 'Recreation' },
            Publishing: { CHI: '出版', ENG: 'Publishing' },
        },
        Tabs: {
            Labels: [
                { CHI: '親子活動推介', ENG: 'Highlighted Programmes' },
                { CHI: '家長資訊', ENG: 'Useful Info' },
            ],
        },
    },
    Recruit: {
        Title: { CHI: '招聘資訊', ENG: 'Recruitment Information' },
        Content: { CHI: '本校誠招下述職位:', ENG: '' },
        PDF: { CHI: '申請表格下載', ENG: 'Download Application Form' },
        Footer: {
            CHI: [
                '因應「性罪行定罪紀錄查核」機制經已實施，本校會要求有關職位的準僱員進行性罪行定罪紀錄查核的申請。',
                '僱員言論及行為不可涉及危害國家安全或違反香港法律(包括但不限於香港國安法)。',
                '(所有資料將予保密及只作招聘有關職位用途)',
            ],
        }
    },
    SchoolProfile: {
        ExternalSchoolReview: [
            {
                CHI: '校外評核報告',
                ENG: 'External School Review Reports',
                URL: 'https://www.pohtyh.edu.hk/Files/ExternalSchoolReview/校外評核報告.pdf'
            },
            {
                CHI: '學校對校外評核報告的回應',
                ENG: 'School\'s Response to School Review Reports',
                URL: 'https://www.pohtyh.edu.hk/Files/ExternalSchoolReview/學校對校外評核報告的回應.pdf'
            },
        ],
        MissionVision: {
            MissionTitle: {
                CHI: '博愛醫院教育服務之抱負',
                ENG: 'The Ambition of Pok Oi Hospital\'s Educational Services'
            },
            MissionContent: {
                CHI: ['以「博文愛德」為校訓，培育「博愛」精神；支持專業領導及教學，營造優良學習氛圍，與持分者共建尚學社群；促進學生全人發展，建立高尚品格及正確人生觀，終身學習，追求卓越；培養學生成為才德兼備、獨立思考、善於溝通、具國際視野、重視文化承傳、關愛社會及國家、具領導能力的人才。'],
                ENG: ['以「博文愛德」為校訓，培育「博愛」精神；支持專業領導及教學，營造優良學習氛圍，與持分者共建尚學社群；促進學生全人發展，建立高尚品格及正確人生觀，終身學習，追求卓越；培養學生成為才德兼備、獨立思考、善於溝通、具國際視野、重視文化承傳、關愛社會及國家、具領導能力的人才。'],
            },
            VisionTitle: { CHI: '我們的願景', ENG: 'Our Vision' },
            VisionContent: {
                CHI: ['我們本著博愛醫院「博愛」精神作為培育學生的總方向，以「博文愛德」為校訓，透過持續專業發展，建立一支具教育理想、關愛學生的教育團隊，致力為學生提供一個全方位的學習環境，使學生在愉快、和諧的學習氣氛下，充份發揮個人潛能，學會學習，自律守規，愛己愛人，多元發展，成為社會和國家的棟樑。'],
                ENG: ['Adhering to the mission of Pok Oi Hospital to ‘Love, Care and Serve’ the community as well as our school motto to help our students grow as people of great erudition and virtues, we are committed to providing them with an all-round education in a harmonious learning environment. To practise what we preach, we believe continuous development plays a pivotal role in building a caring and professional education team to help students strengthen their learning capabilities, develop self-discipline and learn to love, eventually reaching their full potential and serving the community and the nation.']
            },
        },
        MottoSchoolSong: {
            Motto: [
                {
                    Char: '博',
                    Description: '博學於文，約己以禮。《論語·顏淵》'
                },
                {
                    Char: '文',
                    Description: '文質彬彬，然後君子。《論語·雍也》'
                },
                {
                    Char: '愛',
                    Description: '君子愛人也以德。《禮記．檀弓上》'
                },
                {
                    Char: '德',
                    Description: '德者，性之。'
                },
            ],
        },
        SchoolCalendar: {
            URL: 'https://www.pohtyh.edu.hk/Files/SchoolCalendar2627.pdf',
        },
        SchoolDevelopment: {
            URL: 'https://www.pohtyh.edu.hk/schoolProfile/devPlan2021-2024.pdf',
        },
        SchoolPlanReports2021: [
            {
                CHI: '學校發展計劃(2021-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/Development2021-2024.pdf'
            },
        ],
        SchoolPlanReports2022: [
            {
                CHI: '學校周年報告(2022-2023)',
                ENG: 'School Report(2022-2023)',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/SchoolReport2022_20231212.pdf'
            },
            {
                CHI: '支援推行高中公民與社會發展科的一筆過津貼報告(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/CSReport2022.pdf'
            },
            {
                CHI: '課後學習及支援計劃活動報告表(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/AfterSchoolLearningReport2022.pdf'
            },
            {
                CHI: '全方位學習津貼報告(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/LifeWideLearningReport2022.pdf'
            },
            {
                CHI: '多元學習津貼（其他課程－資優課程）活動報告表(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/DLGReport2022.pdf'
            },
            {
                CHI: '學習支援津貼運用報告(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/SEN2022.pdf'
            },
            {
                CHI: '加強支援非華語學生的中文學與教2022-23學年學校支援摘要',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/NCSSummaryCHI2022.pdf'
            },
            {
                CHI: '2022-2023 NCS School Support Summary',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/NCSSummaryENG2022.pdf'
            },
            {
                CHI: '加強支援非華語學生的中文學與教報告(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/NCSReport2022.pdf'
            },
            {
                CHI: '姊妹學校交流報告書(2022-2023)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/SisterSchoolReport2022.pdf'
            },
        ],
        SchoolPlanReports2023: [
            {
                CHI: '學校周年報告(2023-2024)',
                ENG: 'School Report(2023-2024)',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/學校周年報告(2023-2024).pdf'
            },
            {
                CHI: '學校周年計劃(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/AnnualSchoolPlan2023_20231212.pdf'
            },
            {
                CHI: '學校發展津貼計劃(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/CEGPlan2023.pdf'
            },
            {
                CHI: '支援推行高中公民與社會發展科的一筆過津貼計劃(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/CSPlan2023.pdf'
            },
            {
                CHI: '課後學習及支援計劃活動計劃表(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/AfterSchoolLearningPlan2023.pdf'
            },
            {
                CHI: '校本課後學習及支援計劃校本津貼活動報告(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/校本課後學習及支援計劃_校本津貼活動報告2324.pdf'
            },
            {
                CHI: '全方位學習津貼報告(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/全方位學習津貼報告(2023-2024).pdf'
            },
            {
                CHI: '全方位學習津貼計劃(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/LifeWideLearningPlan2023.pdf'
            },
            {
                CHI: '多元學習津貼（其他課程－資優課程）活動計劃表(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/DLGPlan2023.pdf'
            },
            {
                CHI: '推廣閱讀津貼周年計劃(2023-2024)及報告(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/推廣閱讀津貼周年計劃(2023-2024)及報告(2024-2025).pdf'
            },
            {
                CHI: '支援推行公民與社會發展科一筆過津貼報告(2324)及計劃(2425)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/支援推行公民與社會發展科一筆過津貼報告(2324)及計劃(2425).pdf'
            },
            {
                CHI: '2023-2024 NCS School Support Summary',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/為非華語學生提供的教育支援_學校支援摘要(2023-2024).pdf'
            },
            {
                CHI: '姊妹學校交流報告書(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/內地姊妹學校交流報告書(2023-2024).pdf'
            },
            {
                CHI: '姊妹學校交流計劃書(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/SisterSchoolPlan2023.pdf'
            },
        ],
        SchoolPlanReports2024: [
            {
                CHI: '學校周年計劃(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/學校周年計劃(2024-2025).pdf'
            },
            {
                CHI: '學校周年報告(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/學校周年報告(2024-2025).pdf'
            },
            {
                CHI: '學校發展計劃(2024-2027)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/學校發展計劃(2024-2027).pdf'
            },
            {
                CHI: '學校發展津貼計劃(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/學校發展津貼計劃(2024-2025).pdf'
            },
            {
                CHI: '全方位學習津貼計劃(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/全方位學習津貼計劃(2024-2025).pdf'
            },
            {
                CHI: '全方位學習津貼運用報告(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/全方位學習津貼運用報告(2024-2025).pdf'
            },
            {
                CHI: '校本課後學習及支援計劃(2425)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/校本課後學習及支援計劃(2425).pdf'
            },
            {
                CHI: '「一筆過家長教育津貼」預算(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/「一筆過家長教育津貼」預算(2024-2025).pdf'
            },
            {
                CHI: '家長學生好精神一筆過津貼計劃(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/家長學生好精神一筆過津貼計劃(2024-2025).pdf'
            },
            {
                CHI: '校園好精神一筆過津貼計劃(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/校園好精神一筆過津貼計劃(2024-2025).pdf'
            },
            {
                CHI: '推廣中華文化體驗活動計劃書(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/推廣中華文化體驗活動計劃書(2024-2025).pdf'
            },
            {
                CHI: '推廣閱讀津貼周年計劃(2024-2025)及報告(2023-2024)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/推廣閱讀津貼周年計劃(2024-2025)及報告(2023-2024).pdf'
            },
            {
                CHI: '2024-25 學年 學校支援摘要',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/2024-25 學年 學校支援摘要_中文表格.pdf'
            },
            {
                CHI: 'Education Support Provided for Non-Chinese Speaking (NCS) Student(s) School Support Summary for the 2024/25 School Year',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/2024-25 s.y. School Support Summary_EN.pdf'
            },
            {
                CHI: '支援學校推動校園體育氛圍及「MVPA60」一筆過津貼計劃(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/支援學校推動校園體育氛圍及「MVPA60」一筆過津貼計劃(2024-2025).pdf'
            },
            {
                CHI: '姊妹學校交流計劃書(2024-2025)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/內地姊妹學校交流計劃書(2024-2025).pdf'
            },
        ],
        SchoolPlanReports2025: [
            {
                CHI: '學校周年計劃(2025-2026)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/學校周年計劃(2025-2026).pdf'
            },
            {
                CHI: '全方位學習及姊妹學校津貼計劃(2025-2026)',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/SchoolPlansReports/全方位學習及姊妹學校津貼計劃(2025-2026).pdf'
            },
        ],
        Policy: [
            {
                CHI: '和諧校園政策',
                ENG: '',
                URL: 'https://www.pohtyh.edu.hk/Files/Policy/和諧校園政策.pdf'
            },
            {
                CHI: '投訴政策',
                ENG: 'Complaint Handling Policy',
                URL: 'https://www.pohtyh.edu.hk/Files/Policy/ComplaintHandlingPolicy20230911.pdf'
            },
            {
                CHI: '健康校園政策',
                ENG: 'Healthy Campus Policy',
                URL: 'https://www.pohtyh.edu.hk/Files/Policy/HealthyCampusPolicy20120901.pdf'
            },
            {
                CHI: '防止校園性騷擾政策',
                ENG: 'Campus Sexual Assault Policies',
                URL: 'https://www.pohtyh.edu.hk/Files/Policy/CampusSexualAssaultPolicies20120901.pdf'
            },
        ],
        SchoolProfile: {
            AddressTitle: { CHI: '地址', ENG: 'Address' },
            Address: { CHI: '將軍澳唐賢里二號', ENG: '2 Tong Yin Lane, Tseung Kwan O, New Territories' },
            ContactNoTitle: { CHI: '聯絡電話', ENG: 'Contact No.' },
            ContactNo: '2246 3221',
            FaxNoTitle: { CHI: '傳真號碼', ENG: 'Fax No.' },
            FaxNo: '2246 4514',
            EmailTitle: { CHI: '學校電郵', ENG: 'Email' },
            Email: 'webadmin@pohtyh.edu.hk',
            SupervisorTitle: { CHI: '校監', ENG: 'Supervisor' },
            Supervisor: { CHI: '鄧英喜太平紳士', ENG: 'Mr. Tang Ying Hei, JP' },
            PrincipalTitle: { CHI: '校長', ENG: 'Principal' },
            Principal: { CHI: '李慧校長', ENG: 'Ms. Lee Wai' },
            Transportation: { CHI: '交通方法', ENG: 'Transportation' },
            TransportationDetail: {
                CHI: [
                    '由將軍澳站B2出口離開港鐵站',
                    '右轉，沿唐賢街走',
                    '橫過唐德街過路處',
                    '右轉，沿唐德街走',
                    '到達博愛醫院八十週年鄧英喜中學正門',
                ],
                ENG: [
                    'Exit the MTR station from Exit B2 of Tseung Kwan O Station',
                    'Turn right and walk along Tong Yin Street',
                    'Crossing the Tong Yin Street',
                    'Turn right and walk along Tong Tak Street',
                    'Arrived at the main entrance of P.O.H. 80th Anniversary Tang Ying Hei College',
                ],
            },
        },
    },
    StudentDevelopment: {
        ClassBuilding: {
            Target: {
                Title: { CHI: '班級經營之目標', ENG: 'The Goals of Class Building' },
                Content: {
                    CHI: [
                        '透過推動班級經營，讓學生能在一個安全及愉快的課室環境學習。',
                        '透過不同的活動，讓每位學生一同參與經營，一同建立屬於大家的班，加強學生與學生及老師的關係，提昇學生的社交行為。',
                        '協助學生建立良好的常規及學習習慣，為學生提供一個朋輩互助、協作及分享的共通平台，以提升學生的學科學習成效。',
                    ],
                    ENG: [
                        '透過推動班級經營，讓學生能在一個安全及愉快的課室環境學習。',
                        '透過不同的活動，讓每位學生一同參與經營，一同建立屬於大家的班，加強學生與學生及老師的關係，提昇學生的社交行為。',
                        '協助學生建立良好的常規及學習習慣，為學生提供一個朋輩互助、協作及分享的共通平台，以提升學生的學科學習成效。',
                    ],
                },
            },
            ClassTeacher: {
                Title: { CHI: '雙班主任制度', ENG: '雙班主任制度' },
                Content: {
                    CHI: ['為加強對學生的關顧，全校大部份班別均設兩名班主任。'],
                    ENG: ['為加強對學生的關顧，全校大部份班別均設兩名班主任。']
                },
            },
            Award: {
                Title: { CHI: '班級獎勵計劃', ENG: 'Class Award Program' },
                Content: {
                    CHI: ['透過多元化獎勵計劃，培養學生良好的習慣及歸屬感。以下為近年的活動:'],
                    ENG: ['透過多元化獎勵計劃，培養學生良好的習慣及歸屬感。以下為近年的活動:']
                },
                Table: {
                    Title: {
                        Category: { CHI: '類別', ENG: 'Category' },
                        Item: { CHI: '項目', ENG: 'Item' },
                    },
                    Content: {
                        CHI: [
                            { Category: '德', Item: '班際禮貌比賽' },
                            { Category: '德', Item: '班際準時上課比賽' },
                            { Category: '德', Item: '班際清潔比賽' },
                            { Category: '智', Item: '實時網上課堂積極上課比賽' },
                            { Category: '智', Item: '班際交齊功課比賽' },
                            { Category: '體', Item: '班際球類比賽' },
                            { Category: '體', Item: '班際4x100m接力賽' },
                            { Category: '群', Item: '寫揮春賀新歲活動' },
                            { Category: '群', Item: '雞蛋褓姆計劃' },
                            { Category: '群', Item: '班際競技比賽' },
                            { Category: '美', Item: '班際壁報設計比賽' },
                            { Category: '美', Item: '班際音樂比賽' },
                            { Category: '美', Item: '班際創意班相比賽' },
                        ],
                        ENG: [],
                    },
                }
            }
        },
        DisciplineCounselling: {
            Slogan: { CHI: '嚴而有愛，懲情並重', ENG: '嚴而有愛，懲情並重' },
            Discipline: {
                Title: { CHI: '訓導', ENG: 'Discipline' },
                Purpose: {
                    Title: { CHI: '宗旨', ENG: 'Purpose' },
                    Content: {
                        CHI: ['透過全校性參與訓育工作政策，以學生為本位，推動「懲情並重」的訓育工作以促進學生全人發展，培養高尚品格、正向人生觀及健康的生活方式，為社會及國家培養善於溝通、自律守法、尊重法治、明辨是非、愛己愛人、具領導才能的良好公民。'],
                        ENG: ['透過全校性參與訓育工作政策，以學生為本位，推動「懲情並重」的訓育工作以促進學生全人發展，培養高尚品格、正向人生觀及健康的生活方式，為社會及國家培養善於溝通、自律守法、尊重法治、明辨是非、愛己愛人、具領導才能的良好公民。'],
                    },
                },
                Aim: {
                    Title: { CHI: '目標', ENG: 'Aim' },
                    Content: {
                        CHI: [
                            '維護本校一向良好、純樸的校風，為老師及同學持續提供良好的學與教環境，提升學生的學術成就',
                            '積極跟進學生紀律個案，及時介入並糾正學生稍有偏差的行為，教育學生循規守法、尊重法治、負責任、顧己及人等正確價值觀',
                            '推動「自勵計劃」，為違規學生提供改過遷善的機會，讓學生明辨是非，並鼓勵學生抱正向積極的人生態度',
                            '制定並適時檢討學校訓育政策及規則，為學生提供簡單樸素、秩序井然、與時並進的校園生活，提高學生對學校的歸屬感',
                            '透過各項預防教育工作，強化學生的守法意識，提升學生的自律性，鼓勵學生培養正向人生觀及健康生活方式',
                            '維持學校與家長、社區的良好關係與溝通，促進家、校、社三方合作，為學校及學生持續在社區建立良好形象。',
                        ],
                        ENG: [
                            '維護本校一向良好、純樸的校風，為老師及同學持續提供良好的學與教環境，提升學生的學術成就',
                            '積極跟進學生紀律個案，及時介入並糾正學生稍有偏差的行為，教育學生循規守法、尊重法治、負責任、顧己及人等正確價值觀',
                            '推動「自勵計劃」，為違規學生提供改過遷善的機會，讓學生明辨是非，並鼓勵學生抱正向積極的人生態度',
                            '制定並適時檢討學校訓育政策及規則，為學生提供簡單樸素、秩序井然、與時並進的校園生活，提高學生對學校的歸屬感',
                            '透過各項預防教育工作，強化學生的守法意識，提升學生的自律性，鼓勵學生培養正向人生觀及健康生活方式',
                            '維持學校與家長、社區的良好關係與溝通，促進家、校、社三方合作，為學校及學生持續在社區建立良好形象。',
                        ],
                    },
                },
                Members: {
                    Title: { CHI: '成員', ENG: 'Members' },
                    DirectorOfStudentsAffairs: {
                        Title: { CHI: '訓導主任', ENG: 'Director of Students Affairs' },
                        Member: { CHI: '謝嘉雯老師', ENG: 'Ms. Tse Ka Man' },
                    },
                    DeputyDirectorOfStudentsAffairs: {
                        Title: { CHI: '訓導副主任', ENG: 'Deputy Director of Students Affairs' },
                        Member: { CHI: '黃偉豪老師', ENG: 'Mr Wong Wai Ho' },
                    },
                    TeacherOfStudentsAffairs: {
                        Title: { CHI: '訓導老師', ENG: 'Teacher of Students Affairs' },
                        Member: {
                            CHI: ['鄭詠恩老師、', '阮竹權老師、', '陳頌軒老師、', '陳宇華老師、', '何卓橋老師、', '吳汶僖老師'],
                            ENG: ['鄭詠恩老師、', '阮竹權老師、', '陳頌軒老師、', '陳宇華老師、', '何卓橋老師、', '吳汶僖老師'],
                        },
                    },
                }
            },
            Counselling: {
                Title: { CHI: '輔導', ENG: 'Guidance' },
                Purpose: {
                    Title: { CHI: '宗旨', ENG: 'Purpose' },
                    Content: {
                        CHI: ['本組希望同學在身心靈得到健康成長，愉快地享受校園生活。透過專題講座、工作坊及個人成長的關顧，讓同學獲得學習和啟發潛能的機會，以肯定個人的價值，培養同理心，日後成為充滿正能量的社會主人翁。'],
                        ENG: ['本組希望同學在身心靈得到健康成長，愉快地享受校園生活。透過專題講座、工作坊及個人成長的關顧，讓同學獲得學習和啟發潛能的機會，以肯定個人的價值，培養同理心，日後成為充滿正能量的社會主人翁。'],
                    },
                },
                Vision: {
                    Title: { CHI: '願景', ENG: 'Vision' },
                    Content: {
                        CHI: ['我們期望透過不同類型的專題講座和工作坊，如：乘風航、認識焦慮症、性教育工作坊等，讓同學懂得關顧自己，幫助身邊的人，發揚「博愛」精神。'],
                        ENG: ['我們期望透過不同類型的專題講座和工作坊，如：乘風航、認識焦慮症、性教育工作坊等，讓同學懂得關顧自己，幫助身邊的人，發揚「博愛」精神。'],
                    },
                },
            },
        },
        Houses: {
            Intro: {
                CHI: [
                    '學校推行社制，四社分別以本校校訓「博」、「文」、「愛」、「德」為名。全校師生均獲分配入不同社別。通過各種不同形式的社際活動及比賽，促進學生的五育均衡發展及個人成長。',
                    '各級學生在屬社內如同置身於一個大家庭，社內學兄學姐能夠照顧學弟學妹，加強跨年級學生之間的連繫，在社内能夠建立密切的友誼和團隊友愛的精神。',
                    '另外，本校一直致力培養學生的領導才能。各社均設幹事內閣，讓同學有機會透過參與四社事務，培養其組織和領導能力，以及充分發揮服務精神。'
                ],
                ENG: [
                    '學校推行社制，四社分別以本校校訓「博」、「文」、「愛」、「德」為名。全校師生均獲分配入不同社別。通過各種不同形式的社際活動及比賽，促進學生的五育均衡發展及個人成長。',
                    '各級學生在屬社內如同置身於一個大家庭，社內學兄學姐能夠照顧學弟學妹，加強跨年級學生之間的連繫，在社内能夠建立密切的友誼和團隊友愛的精神。',
                    '另外，本校一直致力培養學生的領導才能。各社均設幹事內閣，讓同學有機會透過參與四社事務，培養其組織和領導能力，以及充分發揮服務精神。'
                ],
            },
        },
        IE: {
            Purpose: {
                Title: { CHI: '宗旨', ENG: 'Purpose of Guidance' },
                Content: {
                    CHI: ['從「人物」、「地方」、「計劃」、「政策」、「過程」五方面推動全校實踐「啟發潛能教育」的理念， 培育學生「刻意」、「關愛」、「樂觀」、「尊重」、「信任」等價值觀，啟發學生的多元潛能。'],
                    ENG: ['從「人物」、「地方」、「計劃」、「政策」、「過程」五方面推動全校實踐「啟發潛能教育」的理念， 培育學生「刻意」、「關愛」、「樂觀」、「尊重」、「信任」等價值觀，啟發學生的多元潛能。'],
                },
            },
            Philosophy: {
                Title: { CHI: '啟發潛能教育理念', ENG: 'Educational Philosophy' },
                Content: {
                    CHI: ['「啟發潛能教育」（Invitational Education）是由美國教育大師威廉柏其（William Purkey）所創立，這套教育理論的要旨是深信所有的人都是有能力、有價值，有責任的；而教育是一種協作的活動，有賴彼此的合作，以便幫助學生開啟他們的潛能；教育的過程與其成果同樣重要。這理論亦深信要改善教育的質素，為學生提供良好的教育，啟發他們的潛能，讓他們能在愉快的環境下有效地學習，我們必須透過5P（Policies政策、Places地方、People人物、Programs計劃及Processes過程）的同時運作，互相配合，始能成效。'],
                    ENG: ['「啟發潛能教育」（Invitational Education）是由美國教育大師威廉柏其（William Purkey）所創立，這套教育理論的要旨是深信所有的人都是有能力、有價值，有責任的；而教育是一種協作的活動，有賴彼此的合作，以便幫助學生開啟他們的潛能；教育的過程與其成果同樣重要。這理論亦深信要改善教育的質素，為學生提供良好的教育，啟發他們的潛能，讓他們能在愉快的環境下有效地學習，我們必須透過5P（Policies政策、Places地方、People人物、Programs計劃及Processes過程）的同時運作，互相配合，始能成效。'],
                },
            },
            Process: {
                Title: { CHI: '本校實施啟發潛能教育的歷程', ENG: '本校實施啟發潛能教育的歷程' },
                Content: [
                    {
                        Year: 2017,
                        Content: {
                            CHI: '國際啟發潛能教育學校大獎 Inviting School Award',
                            ENG: '國際啟發潛能教育學校大獎 Inviting School Award',
                        }
                    },
                    {
                        Year: 2017,
                        Content: {
                            CHI: '本校校長、副校長及核心成員遠赴美國交流',
                            ENG: '本校校長、副校長及核心成員遠赴美國交流',
                        }
                    },
                    {
                        Year: 2019,
                        Content: {
                            CHI: '國際啟發潛能教育成就大獎(一星銀獎) Inviting School 1st Silver Fidelity Award',
                            ENG: '國際啟發潛能教育成就大獎(一星銀獎) Inviting School 1st Silver Fidelity Award',
                        }
                    },
                    {
                        Year: 2021,
                        Content: {
                            CHI: '國際啟發潛能教育成就大獎(二星銀獎) Inviting School 2nd Silver Fidelity Award',
                            ENG: '國際啟發潛能教育成就大獎(二星銀獎) Inviting School 2nd Silver Fidelity Award',
                        }
                    },
                    {
                        Year: 2023,
                        Content: {
                            CHI: '國際啟發潛能教育成就大獎(三星銀獎) Inviting School 3rd Silver Fidelity Award',
                            ENG: '國際啟發潛能教育成就大獎(三星銀獎) Inviting School 3rd Silver Fidelity Award',
                        }
                    },
                    {
                        Year: 2023,
                        Content: {
                            CHI: '本校核心成員遠赴夏威夷交流',
                            ENG: '本校核心成員遠赴夏威夷交流',
                        }
                    },
                ],
            },
            LetMeShine: {
                Title: { CHI: 'Let Me Shine 計劃', ENG: 'Let Me Shine Program' },
                Content: {
                    CHI: ['本組設立早會、午間表演平台，讓學生展現九大潛能，一同閃耀。'],
                    ENG: ['本組設立早會、午間表演平台，讓學生展現九大潛能，一同閃耀。'],
                },
            },
        },
        LifePlanning: {
            Purpose: {
                Title: { CHI: '宗旨與目標', ENG: 'Purpose and Objectives' },
                Content: {
                    CHI: [
                        '“Life / Work Planning is a deliberate process to plan one\'s life holistically, including major life domains such as work, learning, relationships, and leisure; to engage actively in steps to implementing these plans in one\'s social context.”',
                        '「事業 / 生涯規劃是一個深思熟慮的過程，讓人能整全地規劃一生，包括生命中重要的範疇，如工作、學習、關係和閒暇。這過程也讓人在其社會環境中一步一步地積極實施所定的計劃。」(梁湘明(2005)。生涯規劃：跨理論假設與實施策略。亞洲輔導學報。12(1 / 2)。79 - 83)',
                        '「以人為本，多元潛能，多元出路！」',
                        '「正面人生觀，自主生涯規劃，具備世界觀的發展方向」',
                    ],
                    ENG: [
                        '“Life / Work Planning is a deliberate process to plan one\'s life holistically, including major life domains such as work, learning, relationships, and leisure; to engage actively in steps to implementing these plans in one\'s social context.”',
                        '「事業 / 生涯規劃是一個深思熟慮的過程，讓人能整全地規劃一生，包括生命中重要的範疇，如工作、學習、關係和閒暇。這過程也讓人在其社會環境中一步一步地積極實施所定的計劃。」(梁湘明(2005)。生涯規劃：跨理論假設與實施策略。亞洲輔導學報。12(1 / 2)。79 - 83)',
                        '「以人為本，多元潛能，多元出路！」',
                        '「正面人生觀，自主生涯規劃，具備世界觀的發展方向」',
                    ],
                },
            },
            Strategy: {
                Title: { CHI: '策略', ENG: 'Strategy' },
                Content: {
                    CHI: [
                        '個人化：尊重個人特質及價值觀，予以個人化輔導，由初中起步建構整全生涯規劃計劃',
                        '國際化：迎合國際趨勢，融入世界觀於生涯規劃計劃，推動升學及就業發展國際化',
                        '啟發潛能教育：參考「啟發潛能教育」理念(5P)，制訂生涯規劃發展藍圖',
                    ],
                    ENG: [
                        '個人化：尊重個人特質及價值觀，予以個人化輔導，由初中起步建構整全生涯規劃計劃',
                        '國際化：迎合國際趨勢，融入世界觀於生涯規劃計劃，推動升學及就業發展國際化',
                        '啟發潛能教育：參考「啟發潛能教育」理念(5P)，制訂生涯規劃發展藍圖',
                    ],
                },
            },
            Blueprint: {
                Title: { CHI: '校本生涯規劃發展藍圖', ENG: 'Development blueprint' },
                Content: {
                    CHI: [
                        '定朝檢視生涯規劃發展藍圖，配合學校願景、啟發潛能教育、教育局中學生涯規劃教育及升學就業輔導指引',
                        '推動全校參與模式：生涯規劃組專責、跨科課程協作、跨行政部門協作、班級經營推動',
                    ],
                    ENG: [
                        '定朝檢視生涯規劃發展藍圖，配合學校願景、啟發潛能教育、教育局中學生涯規劃教育及升學就業輔導指引',
                        '推動全校參與模式：生涯規劃組專責、跨科課程協作、跨行政部門協作、班級經營推動',
                    ]
                },
            },
            GoogleForm: {
                CHI: '生涯規劃支援 - 按此登入Google帳戶並填寫表格內容',
                ENG: '生涯規劃支援 - 按此登入Google帳戶並填寫表格內容',
            },
            EducationInfo: {
                Title: { CHI: '升學資訊', ENG: 'Education Info' },
                LocalEducation: { CHI: '本地升學', ENG: 'Local Education' },
                NonLocalEducation: { CHI: '非本地升學', ENG: 'Non-local Education' },
                CareerInfo: { CHI: '職業資訊', ENG: 'Career Info' },
            },
            Tools: {
                Title: { CHI: '校內生涯規劃工具卡及書籍', ENG: 'Tools and Books for Life Planning' },
                Description: {
                    CHI: '不能盡錄，歡迎同學到Dream Room(生涯規劃室)借用或借閱',
                    ENG: 'It is not possible to list all of them. Students are welcome to borrow in Dream Room'
                },
            },
            IG: {
                Title: { CHI: '本組官方Instagram', ENG: 'Official Instagram of the Group' },
            },
        },
        MoralCivicNationalEducation: {
            CaringSchool: {
                Title: { CHI: '關愛校園', ENG: 'Caring School' },
                Content: {
                    CHI: ['本校就BLESS(Belief (信念)、Leadership(領導)、Environment(環境)、Support(支援)、Sharing(分享))五個範疇推動關愛校園，並由2011年起每年均獲「關愛校園」獎項。'],
                    ENG: ['本校就BLESS(Belief (信念)、Leadership(領導)、Environment(環境)、Support(支援)、Sharing(分享))五個範疇推動關愛校園，並由2011年起每年均獲「關愛校園」獎項。'],
                },
            },
            LifeEducation: {
                Title: { CHI: '初中生命教育', ENG: 'Life Education' },
                Content: {
                    CHI: [
                        '宗旨: 愛己愛人，珍惜生命',
                        '課程大崗:',
                        '中一: 學習十二個首要培養的價值觀，培養正確的生活態度；認識「正向教育」中的性格強項，建立健康的自我形象。',
                        '中二: 與家人、朋友建立美好的關係，並學習男女相處之道。',
                        '中三: 擴闊視野，認識學校、社區、香港及祖國，規劃自己的人生。',
                    ],
                    ENG: [
                        '宗旨: 愛己愛人，珍惜生命',
                        '課程大崗:',
                        '中一: 培養六大品格，學習自我管理，勝過誘惑。',
                        '中二: 與家人、朋友建立美好的關係，並學習男女相處之道。',
                        '中三: 擴闊視野，認識學校、社區、香港及祖國，規劃自己的人生。',
                    ],
                },
            },
            PositiveEducation: {
                Title: { CHI: '正向教育', ENG: 'Positive Education' },
                Content: {
                    CHI: [
                        '本校讓同學發揮自己的性格強項(Character Strengths)，並從以下六個範疇（PERMAH）建立幸福感。',
                        '正向情緒 (Positive Emotions)：正向情緒是幸福理論的基石，它就是指可以讓我們產生愉悅、高興、溫暖、舒服等主觀的感覺，能夠成功引導到這種元素的生活，稱之為愉悅的生活 (Pleasant Life)。',
                        '全情投入(Engagement)：當人集中在做一些他真正享受和重視的事情，就會全心投入在此時此刻。在正向心理學中，這種投入的狀態，稱為「神馳」(FLOW)。',
                        '正向關係(Positive Relationship)：正向關係包括定期接觸溝通及進行活動、互相關心及幫助，和互相欣賞及表達謝意。這些正向關係使個人得到聆聽、安慰、鼓勵和提醒，令自己有足夠的能力面對困難和逆境。',
                        '意義(Meaning)：意義是個人的歸屬感，這個東西給個人帶來超越它本身的價值。若果人要感到幸福快樂，就必須感到生活有意義和有價值。',
                        '成就感(Achievement)：成就感是一個人完成一件事情或者做一件事情時，為自己所做的事情感到愉快或成功的感覺。',
                        '身心健康(Health)：不僅是沒有疾病，更是指身體、心理和社會適應方面完全積極的狀態。',
                    ],
                    ENG: [
                        '本校讓同學發揮自己的性格強項(Character Strengths)，並從以下六個範疇（PERMAH）建立幸福感。',
                        '正向情緒 (Positive Emotions)：正向情緒是幸福理論的基石，它就是指可以讓我們產生愉悅、高興、溫暖、舒服等主觀的感覺，能夠成功引導到這種元素的生活，稱之為愉悅的生活 (Pleasant Life)。',
                        '全情投入(Engagement)：當人集中在做一些他真正享受和重視的事情，就會全心投入在此時此刻。在正向心理學中，這種投入的狀態，稱為「神馳」(FLOW)。',
                        '正向關係(Positive Relationship)：正向關係包括定期接觸溝通及進行活動、互相關心及幫助，和互相欣賞及表達謝意。這些正向關係使個人得到聆聽、安慰、鼓勵和提醒，令自己有足夠的能力面對困難和逆境。',
                        '意義(Meaning)：意義是個人的歸屬感，這個東西給個人帶來超越它本身的價值。若果人要感到幸福快樂，就必須感到生活有意義和有價值。',
                        '成就感(Achievement)：成就感是一個人完成一件事情或者做一件事情時，為自己所做的事情感到愉快或成功的感覺。',
                        '身心健康(Health)：不僅是沒有疾病，更是指身體、心理和社會適應方面完全積極的狀態。',
                    ],
                },
            },
            ValuesEducation: {
                Title: { CHI: '價值教育', ENG: 'Values Education' },
                Content: {
                    CHI: [
                        '十二種首要的價值觀和態度：「堅毅」、「尊重他人」、「責任感」、「國民身份認同」、「承擔精神」、「誠信」、「仁愛」、「守法」、「同理心」、「勤勞」、「團結」和「孝親」',
                    ],
                    ENG: [
                        '十二種首要的價值觀和態度：「堅毅」、「尊重他人」、「責任感」、「國民身份認同」、「承擔精神」、「誠信」、「仁愛」、「守法」、「同理心」、「勤勞」、「團結」和「孝親」',
                    ],
                },
            },
            PastActivities: {
                Title: { CHI: '過往活動', ENG: 'Past Activities' },
            },
        },
        SocialServicesCommittee: {
            PurposeTitle: { CHI: '社會服務組的宗旨', ENG: 'Purpose of Social Services Committee' },
            PurposeContent: {
                CHI: ['本組以「盡己之力，服務社群」為理念，透過領袖培訓及義工服務，讓學生獲得學習和啟發潛能的機會，以肯定個人在社會上的價值，在日後能於家庭、社區、國家及世界成為積極和負責任的公民。'],
                ENG: ['本組以「盡己之力，服務社群」為理念，透過領袖培訓及義工服務，讓學生獲得學習和啟發潛能的機會，以肯定個人在社會上的價值，在日後能於家庭、社區、國家及世界成為積極和負責任的公民。'],
            },
            VisionTitle: { CHI: '社會服務組的願景', ENG: 'Vision' },
            VisionContent: {
                CHI: ['我們期望透過不同類型的義工活動，如：E世代導航員、賣旗日，讓學生服務社區，發揚「博愛」精神；參與由不同機構舉辦的環保活動，擴闊學生眼界，培養學生對不同社會階層、社區環境的關注和尊重，成為更積極主動及具同理心的青少年。'],
                ENG: ['我們期望透過不同類型的義工活動，如：E世代導航員、賣旗日，讓學生服務社區，發揚「博愛」精神；參與由不同機構舉辦的環保活動，擴闊學生眼界，培養學生對不同社會階層、社區環境的關注和尊重，成為更積極主動及具同理心的青少年。'],
            },
        },
        StudentLeadership: {
            Purpose: {
                Title: { CHI: '宗旨', ENG: 'Purpose' },
                Content: {
                    CHI: [
                        '透過多元化的培訓、服務及其他實踐活動，發掘及發揮學生潛能，培育學生領袖。提升學生領袖才能，使學生有能力肩負起領袖角色，讓其建立自信、加強成功感，從而增加對學校的歸屬感、建立薪火相傳、關愛及互助的校園氣氛。學生的領袖才能得以建立，將來也能在社會不同領域作出貢獻，成為社會棟樑。'
                    ],
                    ENG: [
                        '透過多元化的培訓、服務及其他實踐活動，發掘及發揮學生潛能，培育學生領袖。提升學生領袖才能，使學生有能力肩負起領袖角色，讓其建立自信、加強成功感，從而增加對學校的歸屬感、建立薪火相傳、關愛及互助的校園氣氛。學生的領袖才能得以建立，將來也能在社會不同領域作出貢獻，成為社會棟樑。'
                    ],
                },
            },
            Aim: {
                Title: { CHI: '工作目標', ENG: 'Aim' },
                Content: {
                    CHI: [
                        '舉辦多元化的學生領袖培育活動，提升學生領袖才能，加強學生的自信、成功感及歸屬感。',
                        '建立層遞式的管理階梯，以上級帶領下屬的模式，訓練領袖的素質。同時，在帶領及指導組員的過程中，可達致意見交流、督促改進及薪火相傳之效。另外，提供一個晉升的階梯，讓學生有奮鬥的目標。',
                        '建立團隊形象及學生領袖標誌，凝聚團隊精神及氣氛。',
                        '透過跨部門合作，培育學生多方面的才能及建立關愛、互助的校園氣氛。',
                        '發掘社區資源，提供實踐及鍛鍊機會，擴闊學生服務經驗及視野。',
                        '建立完善的服務紀錄及獎勵計劃，鼓勵學生領袖積極參與活動，加強其成功感及歸屬感。',
                        '積極參與校外優秀學生選舉或活動，讓學生汲取經驗、擴闊學生視野及從中認識自己，得到自我肯定。',
                    ],
                    ENG: [
                        '舉辦多元化的學生領袖培育活動，提升學生領袖才能，加強學生的自信、成功感及歸屬感。',
                        '建立層遞式的管理階梯，以上級帶領下屬的模式，訓練領袖的素質。同時，在帶領及指導組員的過程中，可達致意見交流、督促改進及薪火相傳之效。另外，提供一個晉升的階梯，讓學生有奮鬥的目標。',
                        '建立團隊形象及學生領袖標誌，凝聚團隊精神及氣氛。',
                        '透過跨部門合作，培育學生多方面的才能及建立關愛、互助的校園氣氛。',
                        '發掘社區資源，提供實踐及鍛鍊機會，擴闊學生服務經驗及視野。',
                        '建立完善的服務紀錄及獎勵計劃，鼓勵學生領袖積極參與活動，加強其成功感及歸屬感。',
                        '積極參與校外優秀學生選舉或活動，讓學生汲取經驗、擴闊學生視野及從中認識自己，得到自我肯定。',
                    ],
                },
            },
            Strategy: {
                Title: { CHI: '學生培育策略', ENG: 'Strategy of Student Development' },
                Content: {
                    CHI: [
                        '培訓學業及品行中上學生，建立模範榜樣，加強其協助其他有需要學生的能力。',
                        '從初中學生培訓入手，培育學生的領袖素質及建立學生領袖班底。',
                        '提供校內及校外多元化的培訓活動，培養學生領袖特質及加強學生服務工作的技巧。',
                        '透過不同服務的體驗，讓學生從實踐中培養及體現學生領袖特質。',
                        '鼓勵及推動學生參與校外選舉或其他活動，擴闊學生視野。',
                        '平衡學生領袖服務、培訓及學業的時間，重視培訓活動的素質。',
                        '從服務、培訓活動中激發學生潛能，加強學生對自我完善的要求，力求不斷進步。',
                        '激發學生的主動性。給予學生主動參加活動的機會，讓他們學會「爭取」。此外，活動中也讓學生多給予意見及做決定。同時，老師須與他們討論及分析，讓他們瞭解自己決定/行事背後的原因及理據，增強他們認識自己及建立一套正面的價值觀及世界觀。',
                    ],
                    ENG: [
                        '培訓學業及品行中上學生，建立模範榜樣，加強其協助其他有需要學生的能力。',
                        '從初中學生培訓入手，培育學生的領袖素質及建立學生領袖班底。',
                        '提供校內及校外多元化的培訓活動，培養學生領袖特質及加強學生服務工作的技巧。',
                        '透過不同服務的體驗，讓學生從實踐中培養及體現學生領袖特質。',
                        '鼓勵及推動學生參與校外選舉或其他活動，擴闊學生視野。',
                        '平衡學生領袖服務、培訓及學業的時間，重視培訓活動的素質。',
                        '從服務、培訓活動中激發學生潛能，加強學生對自我完善的要求，力求不斷進步。',
                        '激發學生的主動性。給予學生主動參加活動的機會，讓他們學會「爭取」。此外，活動中也讓學生多給予意見及做決定。同時，老師須與他們討論及分析，讓他們瞭解自己決定/行事背後的原因及理據，增強他們認識自己及建立一套正面的價值觀及世界觀。',
                    ],
                },
            },
        },
        StudentsUnion: {
            Purpose: {
                Title: { CHI: '宗旨', ENG: 'Purpose' },
                Content: {
                    CHI: [
                        '作為學校與同學之間的橋樑，加強同學與校方之溝通。',
                        '配合學校啟發潛能之發展，為同學舉辦多元化活動，服務同學。'
                    ],
                    ENG: [
                        '作為學校與同學之間的橋樑，加強同學與校方之溝通。',
                        '配合學校啟發潛能之發展，為同學舉辦多元化活動，服務同學。'
                    ],
                },
            },
            Vision: {
                Title: { CHI: '願景', ENG: 'Vision' },
                Content: {
                    CHI: ['透過籌辦各項活動，讓同學的潛能在各個崗位發揮，啟發他們的創意。鼓勵同學勇敢嘗試，並在成功裡學習謙卑，在失敗裡學習堅毅，裝備自己將來成為勇於承擔的領袖。'],
                    ENG: ['透過籌辦各項活動，讓同學的潛能在各個崗位發揮，啟發他們的創意。鼓勵同學勇敢嘗試，並在成功裡學習謙卑，在失敗裡學習堅毅，裝備自己將來成為勇於承擔的領袖。'],
                },
            },
        },
        UniformedGroups: {
            AirScout: {
                Title: { CHI: '空童軍', ENG: 'Air Scout' },
                Intro: {
                    CHI: [
                        '引用童軍誓詞及規律，協助青少年建立個人的價值觀。',
                        '透過不同的童軍訓練方法，激勵青少年自我學習和啟發，培訓他們成為一個有自立能力、樂於助人、有責任感及勇於承擔的人;',
                        '本旅透過富挑戰性和有進度性的訓練和活動，促進青少年德、智、體、群、美五育的發展;',
                        '本旅舉辦的活動例子:',
                    ],
                    ENG: [
                        '引用童軍誓詞及規律，協助青少年建立個人的價值觀。',
                        '透過不同的童軍訓練方法，激勵青少年自我學習和啟發，培訓他們成為一個有自立能力、樂於助人、有責任感及勇於承擔的人;',
                        '本旅透過富挑戰性和有進度性的訓練和活動，促進青少年德、智、體、群、美五育的發展;',
                        '本旅舉辦的活動例子:',
                    ],
                },
                Activities: {
                    CHI: ['模擬飛行訓練', '步操訓練', '戶外釣魚', '參觀香港國際機場', '燒烤', '制作風箏'],
                    ENG: ['模擬飛行訓練', '步操訓練', '戶外釣魚', '參觀香港國際機場', '燒烤', '制作風箏'],
                }
            },
            GirlGuides: {
                Title: { CHI: '女童軍', ENG: 'Girl Guides' },
                Intro: {
                    CHI: ['女童軍為隊員提供不同的興趣訓練和活動，透過多元化的活動，女童軍可以提升知識技能和品格，建立自信。女童軍亦積極參與校內活動如陸運會和典禮的儀仗工作，從而讓隊長從中學會各種領袖技巧，隊員學會服務別人的精神。'],
                    ENG: ['女童軍為隊員提供不同的興趣訓練和活動，透過多元化的活動，女童軍可以提升知識技能和品格，建立自信。女童軍亦積極參與校內活動如陸運會和典禮的儀仗工作，從而讓隊長從中學會各種領袖技巧，隊員學會服務別人的精神。']
                },
            },
            FlagGuards: {
                Title: { CHI: '升旗隊', ENG: 'Flag Guards' },
                Intro: {
                    CHI: ['本校於2011年成立升旗隊並隸屬香港升旗隊總會，總會以推廣學校及團體的升旗文化，讓學生及社會大眾通過親身參與，認識國家、關心國家，增強對國民身分的認同。'],
                    ENG: ['本校於2011年成立升旗隊並隸屬香港升旗隊總會，總會以推廣學校及團體的升旗文化，讓學生及社會大眾通過親身參與，認識國家、關心國家，增強對國民身分的認同。']
                },
            },
        },
    },
    Top: {
        Menu: {
            SchoolProfile: {
                Title: { CHI: '本校簡介', ENG: 'School Profile' },
                Subtitles: [
                    {
                        Title: { CHI: '使命及願景', ENG: 'Mission & Vision' },
                        Page: '/SchoolProfile_MissionVision',
                    },
                    {
                        Title: { CHI: '校訓及校歌', ENG: 'Motto & School Song' },
                        Page: '/SchoolProfile_MottoSchoolSong',
                    },
                    {
                        Title: { CHI: '學校政策', ENG: 'School Policy' },
                        Page: '/SchoolProfile_Policy',
                    },
                    {
                        Title: { CHI: '校長的話', ENG: 'Principal\'s Insight' },
                        Page: '/SchoolProfile_PrincipalsWords',
                    },
                    {
                        Title: { CHI: '學校計劃及報告', ENG: 'School Plans and Reports' },
                        Subtitles: [
                            {
                                Title: { CHI: '2025-2026', ENG: '2025-2026' },
                                Page: '/SchoolProfile_SchoolPlansReports2025',
                            },
                            {
                                Title: { CHI: '2024-2025', ENG: '2024-2025' },
                                Page: '/SchoolProfile_SchoolPlansReports2024',
                            },
                            {
                                Title: { CHI: '2023-2024', ENG: '2023-2024' },
                                Page: '/SchoolProfile_SchoolPlansReports2023',
                            },
                            {
                                Title: { CHI: '2022-2023', ENG: '2022-2023' },
                                Page: '/SchoolProfile_SchoolPlansReports2022',
                            },
                            {
                                Title: { CHI: '2021-2022', ENG: '2021-2022' },
                                Page: '/SchoolProfile_SchoolPlansReports2021',
                            },
                        ],
                    },
                    {
                        Title: { CHI: '校外評核', ENG: 'External School Review' },
                        Page: '/SchoolProfile_ExternalSchoolReview',
                    },
                    /*{
                        Title: { CHI: 'XXXXXXXXXXXXXX學校架構', ENG: 'School Structure' },
                        Page: '/SchoolProfile_SchoolStructure',
                    },*/
                    {
                        Title: { CHI: '校曆表', ENG: 'School Calendar' },
                        Page: '/SchoolProfile_SchoolCalendar',
                    },
                    {
                        Title: { CHI: '基本資料', ENG: 'School Profile' },
                        Page: '/SchoolProfile_SchoolProfile',
                    },
                ],
            },
            LT: {
                Title: { CHI: '學與教', ENG: 'Learning & Teaching' },
                Subtitles: [
                    {
                        Title: { CHI: '課程', ENG: 'Curriculum' },
                        Page: '/LT_Curriculum',
                    },
                    {
                        Title: { CHI: '選修科簡介', ENG: 'Elective Subject Introduction' },
                        Page: '/LT_ElectiveSubjectIntro',
                    },
                    {
                        Title: { CHI: '文憑試開設科目', ENG: 'Subjects of DSE' },
                        Page: '/LT_SubjectsDSE',
                    },
                    {
                        Title: { CHI: '資優教育', ENG: 'Gifted Education' },
                        Page: '/LT_GiftedEducation',
                    },
                    {
                        Title: { CHI: '英語教育', ENG: 'English Learning' },
                        Subtitles: [
                            {
                                Title: { CHI: 'English Newspaper', ENG: 'English Newspaper' },
                                Page: '/LT_E_EnglishLearning',
                            },
                            {
                                Title: { CHI: 'English Corner', ENG: 'English Corner' },
                                Page: '/LT_E_EnglishCorner',
                            },
                            {
                                Title: { CHI: 'Internal Activities', ENG: 'Internal Activities' },
                                Page: '/LT_E_InternalActivities',
                            },
                            {
                                Title: { CHI: 'Training', ENG: 'Training' },
                                Page: '/LT_E_Training',
                            },
                            {
                                Title: { CHI: 'Schemes', ENG: 'Schemes' },
                                Page: '/LT_E_Schemes',
                            },
                            {
                                Title: { CHI: 'External Activities', ENG: 'External Activities' },
                                Page: '/LT_E_ExternalActivities',
                            },
                            {
                                Title: { CHI: 'Meet Our Native English Teachers', ENG: 'Meet Our Native English Teachers' },
                                Page: '/LT_E_Meet',
                            },
                        ],
                    },
                    {
                        Title: { CHI: 'STEAM 教育', ENG: 'STEAM Education' },
                        Page: '/LT_STEAMEducation',
                    },
                    {
                        Title: { CHI: '應用學習科', ENG: 'Applied Learning' },
                        Page: '/LT_AppliedLearning',
                    },
                    {
                        Title: { CHI: '閱讀推廣', ENG: 'Promotion Of Reading' },
                        Page: '/LT_PromotionReading',
                    },
                    {
                        Title: { CHI: '學習支援課程', ENG: 'Learning Support Programme' },
                        Page: '/LT_LearningSupportProgramme',
                    },
                ],
            },
            SD: {
                Title: { CHI: '學生成長', ENG: 'Student Development' },
                Subtitles: [
                    {
                        Title: { CHI: '啓發潛能', ENG: 'Invitational Education' },
                        Page: '/SD_IE',
                    },
                    {
                        Title: { CHI: '生涯規劃', ENG: 'Life Planning' },
                        Page: '/SD_LifePlanning',
                    },
                    {
                        Title: { CHI: '德育、公民及國民教育', ENG: 'Moral, Civic and National Education' },
                        Page: '/SD_MoralCivicNationalEducation',
                    },
                    {
                        Title: { CHI: '社會服務', ENG: 'Social Services Committee' },
                        Page: '/SD_SocialServicesCommittee',
                    },
                    {
                        Title: { CHI: '班級經營', ENG: 'Class Building' },
                        Page: '/SD_ClassBuilding',
                    },
                    {
                        Title: { CHI: '訓導與輔導', ENG: 'Discipline & Counselling' },
                        Page: '/SD_DisciplineCounselling',
                    },
                    {
                        Title: { CHI: '學生組織', ENG: 'Student Organizations' },
                        Subtitles: [
                            {
                                Title: { CHI: '學生領袖', ENG: 'Student Leadership' },
                                Page: '/SD_StudentLeadership',
                            },
                            {
                                Title: { CHI: '學生會', ENG: 'Students\' Union' },
                                Page: '/SD_StudentsUnion',
                            },
                            {
                                Title: { CHI: '四社', ENG: 'Houses' },
                                Page: '/SD_Houses',
                            },
                            {
                                Title: { CHI: '制服團隊', ENG: 'Uniformed Groups' },
                                Page: '/SD_UniformedGroups',
                            },
                        ],
                    },
                    /*{
                        Title: { CHI: '學生事務政策', ENG: 'Student Affairs Policy' },
                        Page: '/SD_StudentAffairsPolicy',
                    },*/
                ],
            },
            ACT: {
                Title: { CHI: '活動', ENG: 'Activities' },
                Subtitles: [
                    {
                        Title: { CHI: '愉快星期五', ENG: 'Happy Friday' },
                        Page: '/ACT_HappyFriday',
                    },
                    {
                        Title: { CHI: '全方位學習日', ENG: 'Life-wide Learning' },
                        Page: '/ACT_LifeWideLearning',
                    },
                    {
                        Title: { CHI: '交流團', ENG: 'Exchange Tour' },
                        Page: '/ACT_ExchangeTour',
                    },
                    {
                        Title: { CHI: '體育活動', ENG: 'Physical Education' },
                        Page: '/ACT_PE',
                    },
                    {
                        Title: { CHI: '音樂活動', ENG: 'Music' },
                        Page: '/ACT_Music',
                    },
                    {
                        Title: { CHI: '藝術活動', ENG: 'Visual Arts' },
                        Page: '/ACT_VA',
                    },
                ],
            },
            ACH: {
                Title: { CHI: '學生成就', ENG: 'Achievements' },
                Subtitles: [
                    {
                        Title: { CHI: '校外獎項', ENG: 'External Awards' },
                        Page: '/ACH_AwardsExternal',
                    },
                    {
                        Title: { CHI: '媒體報導', ENG: 'Media and Press Coverage' },
                        Page: '/ACH_MediaPressCoverage',
                    },
                    /*{
                        Title: { CHI: 'XXXXX校友成就', ENG: 'Alumni Achievements' },
                        Page: '/ACT_AlumniAchievements',
                    },*/
                ],
            },
            CampusDevelopment: {
                Title: { CHI: '校園發展', ENG: 'Campus Development' },
                Subtitles: [
                    {
                        Title: { CHI: '特色建設', ENG: 'Characteristic Construction' },
                        Subtitles: [
                            {
                                Title: { CHI: '健身室', ENG: 'ACE Fitness Centre' },
                                Page: '/CD_ACE',
                            },
                            {
                                Title: { CHI: '樂樂音樂廳', ENG: 'MusicRoom' },
                                Page: '/CD_MusicRoom',
                            },
                            {
                                Title: { CHI: '視覺藝術創作室', ENG: 'Visual Arts Studio' },
                                Page: '/ACT_VA',
                            },
                            {
                                Title: { CHI: '蘭亭聚', ENG: 'The Lyceum' },
                                Page: '/CD_LanTingJu',
                            },
                            {
                                Title: { CHI: '貽園', ENG: 'Blessed Botanicals' },
                                Page: '/CD_BlessedBotanicals',
                            },
                            {
                                Title: { CHI: 'Café Geographie', ENG: 'Café Geographie' },
                                Page: '/CD_CafeGeographie',
                            },
                        ],
                    },
                    {
                        Title: { CHI: '環保及科技建設', ENG: 'Environmental Protection and Technology Construction' },
                        Subtitles: [
                            {
                                Title: { CHI: '太陽能發電系統', ENG: 'Solar Photovoltaic Systems' },
                                Page: '/CD_SolarPhotovoltaicSystems',
                            },
                            {
                                Title: { CHI: '資訊科技', ENG: 'Information Technology' },
                                Page: '/CD_IT',
                            },
                            {
                                Title: { CHI: '環境政策', ENG: 'Environmental Policy' },
                                Page: '/CD_Environmental',
                            },
                            {
                                Title: { CHI: '認識你的碳足印', ENG: 'Know Your Carbon Footprint' },
                                Page: '/CD_CarbonFootprint',
                            },
                        ],
                    },
                ],
            },
            ADM: {
                Title: { CHI: '入學資訊', ENG: 'Admission' },
                Subtitles: [
                    {
                        Title: { CHI: '本校特色', ENG: 'School Characteristics' },
                        Page: '/ADM_Characteristics',
                    },
                    /*{
                        Title: { CHI: '中一學位申請', ENG: 'S1 Application' },
                        Page: '/ADM_S1Application',
                    },*/
                    {
                        Title: { CHI: '中一學位申請', ENG: 'S1 Application' },
                        /*Title: { CHI: '中一註冊及叩門', ENG: 'S1 Registration & Door-Knocking' },*/
                        Page: '/ADM_S1Registration',
                    },
                    {
                        Title: { CHI: '中一收生程序及行事曆', ENG: 'Procedures and Calendar of S1 Admission' },
                        Page: '/ADM_S1Admission',
                    },
                    /*{
                        Title: { CHI: 'XXXXXXXXXX中二、中三學位申請', ENG: 'S2 & S3 Application' },
                        Page: '/ADM_S2S3Application',
                    },*/
                    {
                        Title: { CHI: '插班生申請須知', ENG: 'Transfer Students Application Guidelines' },
                        Page: '/ADM_TransferStudents',
                    },
                    {
                        Title: { CHI: '基本資料', ENG: 'School Profile' },
                        Page: '/SchoolProfile_SchoolProfile',
                    },
                ],
            },
        }
    },
    UniPass: {
        Title: { CHI: '電腦密碼更改', ENG: 'Reset Password' },
        Intro: {
            CHI: '電腦密碼更改會影響以下內聯網帳戶:',
            ENG: '電腦密碼更改會影響以下內聯網帳戶:'
        },
        Description: {
            CHI: [
                '校園電腦登入',
                '網絡磁碟機連接',
                'Google App For Education',
                'MyTYH',
                'eClass',
                '校務發展綜合平台',
            ],
            ENG: [
                'Campus Computer Login',
                'Connection of Network Drive',
                'Google App For Education',
                'MyTYH',
                'eClass',
                'SADC Platform',
            ],
        },
        Notice: {
            CHI: '密碼更改後大約需要一小時才可用新密碼登入Google服務',
            ENG: '密碼更改後大約需要一小時才可用新密碼登入Google服務'
        },
        Account: { CHI: '登入帳號', ENG: 'ID' },
        OldPassword: { CHI: '舊密碼', ENG: 'Old Password' },
        NewPassword: { CHI: '新密碼', ENG: 'New Password' },
        ConfirmPassword: { CHI: '新密碼(確認)', ENG: 'New Password(Confirm)' },
        Error: {
            UID: { CHI: '請提供登入帳號', ENG: 'Please provide your ID' },
            OldPassword: { CHI: '請提供舊密碼', ENG: 'Please fill in your old password' },
            NewPassword: { CHI: '請提供新密碼', ENG: 'Please fill in your new password' },
            ConfirmPassword: { CHI: '新密碼確認不一致', ENG: 'New password not match' },
            STID: { CHI: '請提供學生編號', ENG: 'Please provide your Student ID' },
            HKID: { CHI: '請提供香港身份証號碼英文字及首六位數字', ENG: 'Please provide your Hong Kong ID Card No.' },
        },
        Modify: { CHI: '更新密碼', ENG: 'Reset Password' },
        Forgot: { CHI: '忘記舊密碼(只限學生帳戶)', ENG: 'Forgot Old Password(For Student Account Only)' },
        ForgotDescription: {
            CHI: '請輸入學生編號及身份證號碼，以確認你的學生身份。',
            ENG: 'Please fill in the student ID and Hong Kong Identity Card No. for the authentication.'
        },
        StudentID: { CHI: '學生編號', ENG: 'Student ID' },
        HKID: { CHI: '香港身份証號碼英文字及首六位數字', ENG: 'Hong Kong Identity Card No.' },
        StudentIDPlaceholder: 'sXXXXXXXX',
        HKIDPlaceholder: 'A123456',
        ForgotResetFail: {
            CHI: '無法重設你的密碼，請檢查你提供的資料是否正確',
            ENG: 'Please check your info before reset the password'
        },
        ForgotAutoReset: { CHI: '你的密碼重設為:', ENG: 'Your new password has been reset as the following:' },
    },
    UniPassParent: {
        Title: { CHI: '補領家長帳戶', ENG: 'Application for re-issuance of Parent Account' },
        Intro: {
            CHI: '如需補領家長帳戶，請家長於學校辦工時間上午8時至下午5時致電22463221聯絡校務處，或填妥下列申請表。',
            ENG: '如需補領家長帳戶，請家長於學校辦工時間上午8時至下午5時致電22463221聯絡校務處，或填妥下列申請表。'
        },
        Description: {
            CHI: '請家長輸入　貴子弟的班別及姓名，本校將於三個工作天內以保密信件通知貴家長的帳戶資料。',
            ENG: '請家長輸入　貴子弟的班別及姓名，本校將於三個工作天內以保密信件通知貴家長的帳戶資料。',
        },
        Error: { CHI: '請提供正確的資料', ENG: 'Please provide your information' },
        Sent: { CHI: '申請已被送出', ENG: 'The application has been sent' },
    },
    VAWork: {
        Title: { CHI: '視藝科藝術創作園地', ENG: 'Visual Arts Creation' },
        Subtitle: {
            F1: { CHI: '中一作品', ENG: 'F.1 Works' },
            F2: { CHI: '中二作品', ENG: 'F.2 Works' },
            F3: { CHI: '中三作品', ENG: 'F.3 Works' },
            F6: { CHI: '高中學生作品', ENG: 'Senior Form Student Works' },
        },
    },
}